export const rentalData = 
{
  "hits": [
    {
      "id": 1919953,
      "ownerID": 1060127,
      "userExternalID": "1060127",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.191772,
        "lng": 55.272181
      },
      "geography": {
        "lat": 25.191772,
        "lng": 55.272181
      },
      "purpose": "for-rent",
      "price": 19950,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "DP-R-38910",
      "permitNumber": "DOW-29-TLDSY",
      "projectNumber": null,
      "title": "1BR 29 Blvd II Near Dubai Mall Downtown",
      "title_l1": "شقة في 29 بوليفارد 2 بوليفارد 29 وسط مدينة دبي 1 غرف 19950 درهم - 4711777",
      "externalID": "4711777",
      "slug": "1br-29-blvd-ii-near-dubai-mall-downtown-4711777",
      "slug_l1": "1br-29-blvd-ii-near-dubai-mall-downtown-4711777",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 10,
          "level": 2,
          "externalID": "6901",
          "name": "Downtown Dubai",
          "name_l1": "وسط مدينة دبي",
          "slug": "/dubai/downtown-dubai",
          "slug_l1": "/dubai/downtown-dubai",
          "type": "neighbourhood"
        },
        {
          "id": 214,
          "level": 3,
          "externalID": "6905",
          "name": "29 Boulevard",
          "name_l1": "بوليفارد 29",
          "slug": "/dubai/downtown-dubai/29-boulevard",
          "slug_l1": "/dubai/downtown-dubai/29-boulevard"
        },
        {
          "id": 597,
          "level": 4,
          "externalID": "8792",
          "name": "29 Boulevard 2",
          "name_l1": "29 بوليفارد 2",
          "slug": "/dubai/downtown-dubai/29-boulevard/29-boulevard-2",
          "slug_l1": "/dubai/downtown-dubai/29-boulevard/29-boulevard-2",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1596457412,
      "updatedAt": 1666115763,
      "reactivatedAt": 1642597011.869342,
      "rooms": 1,
      "baths": 2,
      "area": 79.24629312,
      "score": 100,
      "score_l1": 65,
      "coverPhoto": {
        "id": 170359863,
        "externalID": "109222020",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.113908584233286,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/170359863/69b6e7b8372a4afeb5a33c553c09126a",
        "main": true
      },
      "photoCount": 20,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971509643016",
        "phone": "+97145587789",
        "proxyMobile": "+971525014205",
        "phoneNumbers": [
          "+97145587789"
        ],
        "mobileNumbers": [
          "+971509643016"
        ]
      },
      "contactName": "Driven Holiday Homes",
      "agency": {
        "id": 326,
        "objectID": 326,
        "name": "Driven Holiday Homes",
        "name_l1": "درفن لبيوت العطلات",
        "externalID": "6756",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "730186",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 123148392,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/123148392/db88eef678134cf09a2586918ef5ad08"
        },
        "slug": "driven-holiday-homes-6756",
        "slug_l1": "driven-holiday-homes-6756",
        "tr": 3,
        "tier": 3,
        "roles": [],
        "active": true,
        "createdAt": "2017-12-14T16:29:11.991788+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "f595d1d",
      "keywords": [
        "lounge",
        "mall",
        "kitchen",
        "كبيرة",
        "parking",
        "مطبخ",
        "spacious",
        "واسعة",
        "مفروشة",
        "بلكونة",
        "صالة",
        "مؤثثة",
        "جاهز",
        "موقف سيارة",
        "مفروش",
        "مول",
        "fitted",
        "balcony",
        "furnished"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1613997353.260376,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663562786.790371
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 873,
      "randBoostScore_l1": 873,
      "floorPlanID": 33454,
      "furnishingStatus": "furnished",
      "extraFields": {},
      "type": "property",
      "cityLevelScore": 1,
      "indyScore": 873,
      "indyScore_l1": 873,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        170359863,
        170359866,
        170359852,
        170359883,
        170359912,
        170359929,
        170359888,
        170359932,
        170359951,
        170359945,
        170359936,
        170359948,
        170359954,
        170359922,
        170359926,
        170359916,
        170359919,
        170359943,
        170359893,
        170359940
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "1919953",
      "_highlightResult": {
        "referenceNumber": {
          "value": "DP-R-38910",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "1BR 29 Blvd II Near Dubai Mall Downtown",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "4711777",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Driven Holiday Homes",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "lounge",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "mall",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "كبيرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "spacious",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "واسعة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "صالة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جاهز",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "fitted",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3647661,
      "ownerID": 1090133,
      "userExternalID": "1090133",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.179872616446,
        "lng": 55.30527615573
      },
      "geography": {
        "lat": 25.179872616446,
        "lng": 55.30527615573
      },
      "purpose": "for-rent",
      "price": 11998,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "1120-Ap-R-1035",
      "permitNumber": null,
      "projectNumber": null,
      "title": "Modern Furnished | Family Oriented | Convenient Location",
      "title_l1": "شقة في شوبا كريك فيستاس شوبا هارتلاند مدينة محمد بن راشد 2 غرف 11998 درهم - 6342399",
      "externalID": "6342399",
      "slug": "modern-furnished-family-oriented-convenient-location-6342399",
      "slug_l1": "modern-furnished-family-oriented-convenient-location-6342399",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 302,
          "level": 2,
          "externalID": "8256",
          "name": "Mohammed Bin Rashid City",
          "name_l1": "مدينة محمد بن راشد",
          "slug": "/dubai/mohammad-bin-rashid-city",
          "slug_l1": "/dubai/mohammad-bin-rashid-city",
          "type": "neighbourhood"
        },
        {
          "id": 835,
          "level": 3,
          "externalID": "8949",
          "name": "Sobha Hartland",
          "name_l1": "شوبا هارتلاند",
          "slug": "/dubai/mohammad-bin-rashid-city/sobha-hartland",
          "slug_l1": "/dubai/mohammad-bin-rashid-city/sobha-hartland",
          "type": "neighbourhood"
        },
        {
          "id": 5240,
          "level": 4,
          "externalID": "11980",
          "name": "Sobha Creek Vistas",
          "name_l1": "شوبا كريك فيستاس",
          "slug": "/dubai/mohammad-bin-rashid-city/sobha-hartland/sobha-creek-vistas",
          "slug_l1": "/dubai/mohammad-bin-rashid-city/sobha-hartland/sobha-creek-vistas"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1663403324,
      "updatedAt": 1666082432,
      "reactivatedAt": 1663403324,
      "rooms": 2,
      "baths": 2,
      "area": 73.02178944,
      "score": 100,
      "score_l1": 65,
      "coverPhoto": {
        "id": 272640631,
        "externalID": "130398868",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.555968802858843,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/272640631/b23764a965f448c4b07a504d54f4cc64",
        "main": true
      },
      "photoCount": 12,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971565440231",
        "phone": "+97145572402",
        "whatsapp": "971565440231",
        "proxyPhone": "+97145128215",
        "phoneNumbers": [
          "+97145572402"
        ],
        "mobileNumbers": [
          "+971565440231"
        ]
      },
      "contactName": "Shahzad Gulfam",
      "agency": {
        "id": 29536933,
        "objectID": 29536933,
        "name": "Like Home Vacation Homes Rental",
        "name_l1": "مثل تأجير منازل العطلات المنزلية",
        "externalID": "8933",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "825766",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 75770747,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/75770747/3bc86bb51d114bdeafe816268fff2c26"
        },
        "slug": "like-home-vacation-homes-rental-8933",
        "slug_l1": "like-home-vacation-homes-rental-8933",
        "tr": 1,
        "tier": 1,
        "roles": [],
        "active": true,
        "createdAt": "2019-05-26T07:31:53.147487+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "cec057c",
      "keywords": [
        "مفروشة",
        "عوائل",
        "mall",
        "مودرن",
        "family",
        "مول",
        "مفروش",
        "new",
        "جديدة اول ساكن",
        "ايجار جديد",
        "مؤثثة",
        "حديثة",
        "جديدة",
        "modern",
        "furnished",
        "للعوائل"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1663591934.945729,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663678690.481718
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 811,
      "randBoostScore_l1": 811,
      "floorPlanID": 3054,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu-177078770",
        "dldPropertySK": "dld|mea|ae|tabu-177087851"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 811,
      "indyScore_l1": 811,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        272640631,
        272588153,
        272588154,
        274904431,
        271819540,
        274206289,
        284310698,
        272640639,
        271819544,
        276493888,
        284310702,
        283463270
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "3647661",
      "_highlightResult": {
        "referenceNumber": {
          "value": "1120-Ap-R-1035",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Modern Furnished | Family Oriented | Convenient Location",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "6342399",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Like Home Vacation Homes Rental",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "عوائل",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "mall",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مودرن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "family",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "new",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة اول ساكن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ايجار جديد",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "modern",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "للعوائل",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 2775175,
      "ownerID": 1171362,
      "userExternalID": "1171362",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.068307,
        "lng": 55.12925
      },
      "geography": {
        "lat": 25.068307,
        "lng": 55.12925
      },
      "purpose": "for-rent",
      "price": 10000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "00101121/DECT2",
      "permitNumber": "954129",
      "projectNumber": null,
      "title": "Luke Stays - DEC Tower 2",
      "title_l1": "شقة في برج دي إي سي 2 برج دي إي سي دبي مارينا 1 غرف 10000 درهم - 5512337",
      "externalID": "5512337",
      "slug": "luke-stays-dec-tower-2-5512337",
      "slug_l1": "luke-stays-dec-tower-2-5512337",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 36,
          "level": 2,
          "externalID": "5003",
          "name": "Dubai Marina",
          "name_l1": "دبي مارينا",
          "slug": "/dubai/dubai-marina",
          "slug_l1": "/dubai/dubai-marina",
          "type": "neighbourhood"
        },
        {
          "id": 533,
          "level": 3,
          "externalID": "5014",
          "name": "DEC Towers",
          "name_l1": "برج دي إي سي",
          "slug": "/dubai/dubai-marina/dec-towers",
          "slug_l1": "/dubai/dubai-marina/dec-towers"
        },
        {
          "id": 1164,
          "level": 4,
          "externalID": "11561",
          "name": "DEC Tower 2",
          "name_l1": "برج دي إي سي 2",
          "slug": "/dubai/dubai-marina/dec-towers/dec-tower-2",
          "slug_l1": "/dubai/dubai-marina/dec-towers/dec-tower-2",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1636526335,
      "updatedAt": 1666078596,
      "reactivatedAt": 1660939612.370098,
      "rooms": 1,
      "baths": 2,
      "area": 77.01662016,
      "score": 100,
      "score_l1": 65,
      "coverPhoto": {
        "id": 170951678,
        "externalID": "113940493",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.674000638286515,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/170951678/689b782cfbaf46b5ae2dc9b4764ea00a",
        "main": true
      },
      "photoCount": 14,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971585087963",
        "whatsapp": "971585087963",
        "proxyMobile": "+971521860516",
        "mobileNumbers": [
          "+971585087963"
        ]
      },
      "contactName": "Luke International Rental Homes",
      "agency": {
        "id": 29617052,
        "objectID": 29617052,
        "name": "Luke International Rental Homes L. L. C.",
        "name_l1": "لوك انترناشيونال رينتال هومز ذ.",
        "externalID": "10898",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "954129",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 156097530,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/156097530/1e8de505bfa84319bfc0b21312de7615"
        },
        "slug": "luke-international-rental-homes-llc-10898",
        "slug_l1": "luke-international-rental-homes-llc-10898",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2021-10-10T13:01:33.604591+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "e46814a",
      "keywords": [
        "ارضي",
        "parking",
        "ارضية",
        "مطبخ",
        "ground",
        "موقف سيارة",
        "kitchen",
        "serviced",
        "مخدوم",
        "طابق ارضي"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1643959886.839193,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1665403980.162326
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 810,
      "randBoostScore_l1": 810,
      "floorPlanID": 1648,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu+ejari-149676",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-227601"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 810,
      "indyScore_l1": 810,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        170951678,
        170951677,
        170951673,
        170951679,
        170951680,
        170951686,
        170951688,
        170951685,
        170951681,
        170951684,
        170951661,
        170951690,
        170951665,
        170951645
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "2775175",
      "_highlightResult": {
        "referenceNumber": {
          "value": "00101121/DECT2",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Luke Stays - DEC Tower 2",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5512337",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Luke International Rental Homes L. L. C.",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "ارضي",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ارضية",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ground",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "serviced",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مخدوم",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "طابق ارضي",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 2784076,
      "ownerID": 1171362,
      "userExternalID": "1171362",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.072898,
        "lng": 55.130092
      },
      "geography": {
        "lat": 25.072898,
        "lng": 55.130092
      },
      "purpose": "for-rent",
      "price": 18499,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "151121/SHAMS4",
      "permitNumber": "954129",
      "projectNumber": null,
      "title": "Luke Stays - Shams 4",
      "title_l1": "شقة في شمس 4 شمس جميرا بيتش ريزيدنس 2 غرف 18499 درهم - 5464146",
      "externalID": "5464146",
      "slug": "luke-stays-shams-4-5464146",
      "slug_l1": "luke-stays-shams-4-5464146",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 87,
          "level": 2,
          "externalID": "5549",
          "name": "Jumeirah Beach Residence (JBR)",
          "name_l1": "جميرا بيتش ريزيدنس",
          "slug": "/dubai/jumeirah-beach-residence-jbr",
          "slug_l1": "/dubai/jumeirah-beach-residence-jbr",
          "type": "neighbourhood"
        },
        {
          "id": 126,
          "level": 3,
          "externalID": "8441",
          "name": "Shams",
          "name_l1": "شمس",
          "slug": "/dubai/jumeirah-beach-residence-jbr/shams",
          "slug_l1": "/dubai/jumeirah-beach-residence-jbr/shams"
        },
        {
          "id": 1346,
          "level": 4,
          "externalID": "5553",
          "name": "Shams 4",
          "name_l1": "شمس 4",
          "slug": "/dubai/jumeirah-beach-residence-jbr/shams/shams-4",
          "slug_l1": "/dubai/jumeirah-beach-residence-jbr/shams/shams-4",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1634686215,
      "updatedAt": 1666078587,
      "reactivatedAt": 1660939612.575316,
      "rooms": 2,
      "baths": 2,
      "area": 121.14556416,
      "score": 100,
      "score_l1": 62,
      "coverPhoto": {
        "id": 182157362,
        "externalID": "114655506",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.602824664163215,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/182157362/e1e94b0dfc814ff2bff94a493bc0149d",
        "main": true
      },
      "photoCount": 20,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971585087963",
        "whatsapp": "971585087963",
        "proxyMobile": "+971521860516",
        "mobileNumbers": [
          "+971585087963"
        ]
      },
      "contactName": "Luke International Rental Homes",
      "agency": {
        "id": 29617052,
        "objectID": 29617052,
        "name": "Luke International Rental Homes L. L. C.",
        "name_l1": "لوك انترناشيونال رينتال هومز ذ.",
        "externalID": "10898",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "954129",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 156097530,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/156097530/1e8de505bfa84319bfc0b21312de7615"
        },
        "slug": "luke-international-rental-homes-llc-10898",
        "slug_l1": "luke-international-rental-homes-llc-10898",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2021-10-10T13:01:33.604591+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "d04c1cc",
      "keywords": [
        "floor",
        "2 bedroom",
        "صالة",
        "kitchen",
        "اسبوعي",
        "weekly",
        "مطبخ",
        "مفروش",
        "غرفتين",
        "حديثة",
        "2 غرفة",
        "نظيف",
        "موقف سيارة",
        "clean",
        "serviced",
        "مخدوم",
        "غرفتين نوم",
        "شيرنج",
        "مجلس",
        "شامل الماء والكهرباء",
        "modern",
        "shared",
        "مفروشة",
        "bills included",
        "all bills included",
        "guest",
        "furnished",
        "مودرن",
        "lounge",
        "شامل",
        "مؤثثة",
        "دور",
        "parking",
        "مشتركة"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1644665513.581181,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1665392094.256634
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 756,
      "randBoostScore_l1": 756,
      "floorPlanID": null,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu+ejari-149785",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-161602"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 756,
      "indyScore_l1": 756,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        182157362,
        178320360,
        182157368,
        182157366,
        184185135,
        172593290,
        172593293,
        186234385,
        184185139,
        178320378,
        182157383,
        178320382,
        172593303,
        184075320,
        184185140,
        182157394,
        178320368,
        178320386,
        265677888,
        172593305
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "2784076",
      "_highlightResult": {
        "referenceNumber": {
          "value": "151121/SHAMS4",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Luke Stays - Shams 4",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5464146",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Luke International Rental Homes L. L. C.",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "floor",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "صالة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "اسبوعي",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "weekly",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 غرفة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "نظيف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "clean",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "serviced",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مخدوم",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين نوم",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "شيرنج",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مجلس",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "شامل الماء والكهرباء",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "modern",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "shared",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "bills included",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "all bills included",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "guest",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مودرن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "lounge",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "شامل",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "دور",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مشتركة",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3158155,
      "ownerID": 1821734,
      "userExternalID": "1821734",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.071367,
        "lng": 55.124955
      },
      "geography": {
        "lat": 25.071367,
        "lng": 55.124955
      },
      "purpose": "for-rent",
      "price": 42000,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "100217-at781E",
      "permitNumber": "524",
      "projectNumber": null,
      "title": "Brand new 2 BR apt in 5242 with stunning JBR beach & Seaview",
      "title_l1": "شقة في أبراج 5242 دبي مارينا 2 غرف 42000 درهم - 5880178",
      "externalID": "5880178",
      "slug": "brand-new-2-br-apt-in-5242-with-stunning-jbr-beach-seaview-5880178",
      "slug_l1": "brand-new-2-br-apt-in-5242-with-stunning-jbr-beach-seaview-5880178",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 36,
          "level": 2,
          "externalID": "5003",
          "name": "Dubai Marina",
          "name_l1": "دبي مارينا",
          "slug": "/dubai/dubai-marina",
          "slug_l1": "/dubai/dubai-marina",
          "type": "neighbourhood"
        },
        {
          "id": 1221,
          "level": 3,
          "externalID": "8695",
          "name": "5242 Towers",
          "name_l1": "أبراج 5242",
          "slug": "/dubai/dubai-marina/5242-towers",
          "slug_l1": "/dubai/dubai-marina/5242-towers",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1649593394,
      "updatedAt": 1666079233,
      "reactivatedAt": 1649593394,
      "rooms": 2,
      "baths": 2,
      "area": 105.63075648,
      "score": 100,
      "score_l1": 65,
      "coverPhoto": {
        "id": 211521750,
        "externalID": "121585555",
        "title": "Lounge pix 1",
        "orderIndex": 0,
        "nimaScore": 9.429342464933143,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/211521750/0424b0ccd77d463c856c8a6cda4df03c",
        "main": true
      },
      "photoCount": 9,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971543625755",
        "phone": "+971543625755",
        "proxyMobile": "+971558598951",
        "phoneNumbers": [
          "+971543625755"
        ],
        "mobileNumbers": [
          "+971543625755"
        ]
      },
      "contactName": "Tolu Onanaye",
      "agency": {
        "id": 29635333,
        "objectID": 29635333,
        "name": "Olat Holiday Homes Rental L. L. C",
        "name_l1": "اولا هوليداى هومز رينتالز ذ",
        "externalID": "100217",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "1041669",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 199806572,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/199806572/7a4475e183f74cc893bb71ab4032e5c2"
        },
        "slug": "olat-holiday-homes-rental-llc-100217",
        "slug_l1": "olat-holiday-homes-rental-llc-100217",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2022-04-05T09:05:46.265339+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "7b96e02",
      "keywords": [
        "ساكن اول",
        "جديدة اول ساكن",
        "ايجار جديد",
        "kitchen",
        "غرفتين",
        "مطبخ",
        "مفروشة",
        "للعوائل",
        "luxury",
        "ارضية",
        "اسبوعي",
        "2 غرفة",
        "فاخرة",
        "ground",
        "طابق ارضي",
        "مؤثثة",
        "جديدة",
        "عوائل",
        "weekly",
        "غرفتين نوم",
        "furnished",
        "اول ساكن",
        "ارضي",
        "مفروش",
        "brand new",
        "2 bedroom",
        "family",
        "new"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1649830550.947657,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1664185504.276047
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 586,
      "randBoostScore_l1": 586,
      "floorPlanID": 1446,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu-29930102",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-29930924"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 586,
      "indyScore_l1": 586,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        211521750,
        201438075,
        214061859,
        211521753,
        215125795,
        215125796,
        215141004,
        287453132,
        214061873
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "3158155",
      "_highlightResult": {
        "referenceNumber": {
          "value": "100217-at781E",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Brand new 2 BR apt in 5242 with stunning JBR beach & Seaview",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5880178",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Olat Holiday Homes Rental L. L. C",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "ساكن اول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة اول ساكن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ايجار جديد",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "للعوائل",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "luxury",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ارضية",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "اسبوعي",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 غرفة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "فاخرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ground",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "طابق ارضي",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "عوائل",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "weekly",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين نوم",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "اول ساكن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ارضي",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "brand new",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "family",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "new",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 2933155,
      "ownerID": 713799,
      "userExternalID": "713799",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.193536913457,
        "lng": 55.284457057714
      },
      "geography": {
        "lat": 25.193536913457,
        "lng": 55.284457057714
      },
      "purpose": "for-rent",
      "price": 15000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "UPP - 2",
      "permitNumber": "780436",
      "projectNumber": null,
      "title": "DOWNTOWN || BURJ KHALIFA VIEW || NEAR TO DUBAI MALL ||",
      "title_l1": "شقة فاخرة ومفروشة بأناقة من غرفتي نوم - داماك أعلى قمة",
      "externalID": "5669067",
      "slug": "downtown-burj-khalifa-view-near-to-dubai-mall-5669067",
      "slug_l1": "downtown-burj-khalifa-view-near-to-dubai-mall-5669067",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 10,
          "level": 2,
          "externalID": "6901",
          "name": "Downtown Dubai",
          "name_l1": "وسط مدينة دبي",
          "slug": "/dubai/downtown-dubai",
          "slug_l1": "/dubai/downtown-dubai",
          "type": "neighbourhood"
        },
        {
          "id": 818,
          "level": 3,
          "externalID": "7081",
          "name": "Upper Crest (Burjside Terrace)",
          "name_l1": "أبر كرست",
          "slug": "/dubai/downtown-dubai/upper-crest-burjside-terrace",
          "slug_l1": "/dubai/downtown-dubai/upper-crest-burjside-terrace",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1642758682,
      "updatedAt": 1665561480,
      "reactivatedAt": 1642758682,
      "rooms": 2,
      "baths": 3,
      "area": 98.66302848000001,
      "score": 100,
      "score_l1": 100,
      "coverPhoto": {
        "id": 268431479,
        "externalID": "129949241",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.56864420382103,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/268431479/b3412ea21070492397aae09eede2b6a8",
        "main": true
      },
      "photoCount": 28,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971528585543",
        "phone": "+97147707838",
        "whatsapp": "971528585543",
        "proxyMobile": "+971521439205",
        "phoneNumbers": [
          "+97147707838"
        ],
        "mobileNumbers": [
          "+971528585543"
        ]
      },
      "contactName": "BLUE OCEAN HOLIDAY HOMES RENTAL LLC",
      "agency": {
        "id": 29543389,
        "objectID": 29543389,
        "name": "Blue Ocean Holiday Homes Rental LLC",
        "name_l1": "بلو أوشن هوليداي هومز رينتالز ذ",
        "externalID": "9149",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "780436",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 80459086,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/80459086/11c450b8e166465ba5b9b7fb6293f8c4"
        },
        "slug": "blue-ocean-holiday-homes-rental-llc-9149",
        "slug_l1": "blue-ocean-holiday-homes-rental-llc-9149",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2019-09-26T09:41:29.896692+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "90b9486",
      "keywords": [
        "3 bedroom",
        "مطبخ",
        "مفروشة",
        "بلكونة",
        "kitchen",
        "parking",
        "mall",
        "luxury",
        "investment",
        "heating",
        "2 bedroom",
        "furnished",
        "موقف سيارة",
        "balcony",
        "فاخرة",
        "غرفتين",
        "ثلاث غرف",
        "استثمار",
        "مؤثثة",
        "مول",
        "تدفئة",
        "مفروش"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1663679446.586477,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1664976241.455607
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 543,
      "randBoostScore_l1": 543,
      "floorPlanID": 7485,
      "furnishingStatus": "furnished",
      "extraFields": {},
      "type": "property",
      "cityLevelScore": 1,
      "indyScore": 543,
      "indyScore_l1": 543,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        268431479,
        271131731,
        279046187,
        271131728,
        271131725,
        272573179,
        275442522,
        280651659,
        268431481,
        279046191,
        280651660,
        275442526,
        273943895,
        273943896,
        273943894,
        284277108,
        284277109,
        284277110,
        273950418,
        284277112,
        268431484,
        277178425,
        273943902,
        273943903,
        280651679,
        273943906,
        273943907,
        278307568
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "2933155",
      "_highlightResult": {
        "referenceNumber": {
          "value": "UPP - 2",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "DOWNTOWN || BURJ KHALIFA VIEW || NEAR TO DUBAI MALL ||",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5669067",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Blue Ocean Holiday Homes Rental LLC",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "3 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "mall",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "luxury",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "investment",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "heating",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "فاخرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ثلاث غرف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "استثمار",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "تدفئة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3201633,
      "ownerID": 1912668,
      "userExternalID": "1912668",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.067073483869,
        "lng": 55.203469325513
      },
      "geography": {
        "lat": 25.067073483869,
        "lng": 55.203469325513
      },
      "purpose": "for-rent",
      "price": 13000,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "2504",
      "permitNumber": "JUMPANIIQG1",
      "projectNumber": null,
      "title": "Elegantly Decorated 1 Bedroom Apartment| Brand New | Skyline View",
      "title_l1": "شقة في ابراج بلووم المنطقة 10 قرية جميرا الدائرية 1 غرف 13000 درهم - 5920792",
      "externalID": "5920792",
      "slug": "elegantly-decorated-1-bedroom-apartment-brand-new-skyline-view-5920792",
      "slug_l1": "elegantly-decorated-1-bedroom-apartment-brand-new-skyline-view-5920792",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 59,
          "level": 2,
          "externalID": "5416",
          "name": "Jumeirah Village Circle (JVC)",
          "name_l1": "قرية جميرا الدائرية",
          "slug": "/dubai/jumeirah-village-circle-jvc",
          "slug_l1": "/dubai/jumeirah-village-circle-jvc",
          "type": "neighbourhood"
        },
        {
          "id": 2478,
          "level": 3,
          "externalID": "11840",
          "name": "JVC District 10",
          "name_l1": "المنطقة 10",
          "slug": "/dubai/jumeirah-village-circle-jvc/jvc-district-10",
          "slug_l1": "/dubai/jumeirah-village-circle-jvc/jvc-district-10",
          "type": "neighbourhood"
        },
        {
          "id": 1547,
          "level": 4,
          "externalID": "9140",
          "name": "Bloom Towers",
          "name_l1": "ابراج بلووم",
          "slug": "/dubai/jumeirah-village-circle-jvc/jvc-district-10/bloom-towers",
          "slug_l1": "/dubai/jumeirah-village-circle-jvc/jvc-district-10/bloom-towers",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1651149236,
      "updatedAt": 1666095504,
      "reactivatedAt": 1651149236,
      "rooms": 1,
      "baths": 1,
      "area": 73.76501376,
      "score": 100,
      "score_l1": 65,
      "coverPhoto": {
        "id": 236901797,
        "externalID": "122405049",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.80742459156214,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/236901797/f149fa83441c4eba99b4368d0c4078ce",
        "main": true
      },
      "photoCount": 29,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971581697283",
        "phone": "+97145802357",
        "whatsapp": "971581697283",
        "proxyMobile": "+971527571157",
        "proxyPhone": "+97144298820",
        "phoneNumbers": [
          "+97145802357"
        ],
        "mobileNumbers": [
          "+971581697283"
        ]
      },
      "contactName": "Eman Hajji",
      "agency": {
        "id": 29589916,
        "objectID": 29589916,
        "name": "B L V D Holiday Homes Rental L. L. C",
        "name_l1": "بي ال في دي هوليداي هومز رينتال ذ",
        "externalID": "10204",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "906876",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 99895298,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/99895298/9fc421847605425f9f3227a49d9db7f9"
        },
        "slug": "b-l-v-d-holiday-homes-rental-llc-10204",
        "slug_l1": "b-l-v-d-holiday-homes-rental-llc-10204",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2021-01-03T05:56:44.120343+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "65f1994",
      "keywords": [
        "ايجار جديد",
        "brand new",
        "1 bedroom",
        "مودرن",
        "حديثة",
        "ساكن اول",
        "جديدة اول ساكن",
        "مطبخ",
        "balcony",
        "غرفة واحدة",
        "modern",
        "new",
        "جديدة",
        "بلكونة",
        "kitchen",
        "اول ساكن"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1659705543.227117,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663654609.524622
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 514,
      "randBoostScore_l1": 514,
      "floorPlanID": 3518,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu-101896089",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-101908957"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 514,
      "indyScore_l1": 514,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        236901797,
        234800085,
        236948583,
        237985127,
        229835870,
        210676664,
        236901800,
        229835872,
        229835873,
        232706396,
        229835875,
        229835876,
        262446867,
        240641191,
        210676673,
        229835879,
        234800091,
        236948587,
        236948588,
        234800094,
        229835884,
        229835885,
        254286621,
        229835887,
        234800096,
        229835889,
        229835890,
        229835891,
        236901807
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "3201633",
      "_highlightResult": {
        "referenceNumber": {
          "value": "2504",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Elegantly Decorated 1 Bedroom Apartment| Brand New | Skyline View",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5920792",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "B L V D Holiday Homes Rental L. L. C",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "ايجار جديد",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "brand new",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "1 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مودرن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ساكن اول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة اول ساكن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفة واحدة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "modern",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "new",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "اول ساكن",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3135059,
      "ownerID": 1171362,
      "userExternalID": "1171362",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.068527,
        "lng": 55.128906
      },
      "geography": {
        "lat": 25.068527,
        "lng": 55.128906
      },
      "purpose": "for-rent",
      "price": 10000,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "S107",
      "permitNumber": "954129",
      "projectNumber": null,
      "title": "Luke Stays - Studio One",
      "title_l1": "شقة في برج استوديو ون دبي مارينا 1 غرف 10000 درهم - 5859853",
      "externalID": "5859853",
      "slug": "luke-stays-studio-one-5859853",
      "slug_l1": "luke-stays-studio-one-5859853",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 36,
          "level": 2,
          "externalID": "5003",
          "name": "Dubai Marina",
          "name_l1": "دبي مارينا",
          "slug": "/dubai/dubai-marina",
          "slug_l1": "/dubai/dubai-marina",
          "type": "neighbourhood"
        },
        {
          "id": 113,
          "level": 3,
          "externalID": "8891",
          "name": "Studio One Tower",
          "name_l1": "برج استوديو ون",
          "slug": "/dubai/dubai-marina/studio-one-tower-",
          "slug_l1": "/dubai/dubai-marina/studio-one-tower-",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1648747789,
      "updatedAt": 1666079226,
      "reactivatedAt": 1660939611.994931,
      "rooms": 1,
      "baths": 2,
      "area": 66.33277056,
      "score": 100,
      "score_l1": 65,
      "coverPhoto": {
        "id": 263974315,
        "externalID": "121203612",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.56578681821918,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/263974315/464dd93c5db14f868c390586e0d6a3b4",
        "main": true
      },
      "photoCount": 7,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971585087963",
        "whatsapp": "971585087963",
        "proxyMobile": "+971521860516",
        "mobileNumbers": [
          "+971585087963"
        ]
      },
      "contactName": "Luke International Rental Homes",
      "agency": {
        "id": 29617052,
        "objectID": 29617052,
        "name": "Luke International Rental Homes L. L. C.",
        "name_l1": "لوك انترناشيونال رينتال هومز ذ.",
        "externalID": "10898",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "954129",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 156097530,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/156097530/1e8de505bfa84319bfc0b21312de7615"
        },
        "slug": "luke-international-rental-homes-llc-10898",
        "slug_l1": "luke-international-rental-homes-llc-10898",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2021-10-10T13:01:33.604591+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "e31ac28",
      "keywords": [
        "مجلس",
        "parking",
        "مطبخ",
        "clean",
        "serviced",
        "spacious",
        "guest",
        "مخدوم",
        "موقف سيارة",
        "نظيف",
        "families",
        "واسعة",
        "kitchen",
        "كبيرة",
        "balcony",
        "بلكونة",
        "عوائل"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1651309670.461693,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1664267402.547071
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 470,
      "randBoostScore_l1": 470,
      "floorPlanID": 1867,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu-35712710",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-35714184"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 470,
      "indyScore_l1": 470,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        263974315,
        263974316,
        271402677,
        271340406,
        265200176,
        234232508,
        209509409
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "3135059",
      "_highlightResult": {
        "referenceNumber": {
          "value": "S107",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Luke Stays - Studio One",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5859853",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Luke International Rental Homes L. L. C.",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "مجلس",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "clean",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "serviced",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "spacious",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "guest",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مخدوم",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "نظيف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "families",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "واسعة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "كبيرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "عوائل",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 2823199,
      "ownerID": 1090133,
      "userExternalID": "1090133",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.056234,
        "lng": 55.20391
      },
      "geography": {
        "lat": 25.056234,
        "lng": 55.20391
      },
      "purpose": "for-rent",
      "price": 10499,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "1120-Ap-R-0629",
      "permitNumber": "825766",
      "projectNumber": null,
      "title": "Fully Furnished | Family-Oriented | Best Location",
      "title_l1": "شقة في بلوم هايتس الضاحية 15 قرية جميرا الدائرية 2 غرف 10499 درهم - 5559967",
      "externalID": "5559967",
      "slug": "fully-furnished-family-oriented-best-location-5559967",
      "slug_l1": "fully-furnished-family-oriented-best-location-5559967",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 59,
          "level": 2,
          "externalID": "5416",
          "name": "Jumeirah Village Circle (JVC)",
          "name_l1": "قرية جميرا الدائرية",
          "slug": "/dubai/jumeirah-village-circle-jvc",
          "slug_l1": "/dubai/jumeirah-village-circle-jvc",
          "type": "neighbourhood"
        },
        {
          "id": 2757,
          "level": 3,
          "externalID": "11455",
          "name": "JVC District 15",
          "name_l1": "الضاحية 15",
          "slug": "/dubai/jumeirah-village-circle-jvc/jvc-district-15",
          "slug_l1": "/dubai/jumeirah-village-circle-jvc/jvc-district-15",
          "type": "neighbourhood"
        },
        {
          "id": 2291,
          "level": 4,
          "externalID": "11321",
          "name": "Bloom Heights",
          "name_l1": "بلوم هايتس",
          "slug": "/dubai/jumeirah-village-circle-jvc/jvc-district-15/bloom-heights",
          "slug_l1": "/dubai/jumeirah-village-circle-jvc/jvc-district-15/bloom-heights",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1638272035,
      "updatedAt": 1666078584,
      "reactivatedAt": 1644834146.554789,
      "rooms": 2,
      "baths": 2,
      "area": 98.19851328,
      "score": 100,
      "score_l1": 62,
      "coverPhoto": {
        "id": 234338941,
        "externalID": "125479346",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 8.86490138163208,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/234338941/fc66841b32634bd8a7d1b6d44629b5df",
        "main": true
      },
      "photoCount": 10,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971565440231",
        "phone": "+97145572402",
        "whatsapp": "971565440231",
        "proxyPhone": "+97145128215",
        "phoneNumbers": [
          "+97145572402"
        ],
        "mobileNumbers": [
          "+971565440231"
        ]
      },
      "contactName": "Shahzad Gulfam",
      "agency": {
        "id": 29536933,
        "objectID": 29536933,
        "name": "Like Home Vacation Homes Rental",
        "name_l1": "مثل تأجير منازل العطلات المنزلية",
        "externalID": "8933",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "825766",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 75770747,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/75770747/3bc86bb51d114bdeafe816268fff2c26"
        },
        "slug": "like-home-vacation-homes-rental-8933",
        "slug_l1": "like-home-vacation-homes-rental-8933",
        "tr": 1,
        "tier": 1,
        "roles": [],
        "active": true,
        "createdAt": "2019-05-26T07:31:53.147487+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "a0c3b79",
      "keywords": [
        "family",
        "عوائل",
        "مفروش",
        "furnished",
        "مفروشة",
        "مؤثثة",
        "للعوائل"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1658467828.757494,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663833149.119854
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 449,
      "randBoostScore_l1": 449,
      "floorPlanID": null,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu-48479497",
        "dldPropertySK": "dld|mea|ae|tabu-48483791"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 449,
      "indyScore_l1": 449,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        234338941,
        269056227,
        235819731,
        239702754,
        235819733,
        239702756,
        235819735,
        235819722,
        244308679,
        235819739
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "2823199",
      "_highlightResult": {
        "referenceNumber": {
          "value": "1120-Ap-R-0629",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Fully Furnished | Family-Oriented | Best Location",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5559967",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Like Home Vacation Homes Rental",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "family",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "عوائل",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "للعوائل",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3697314,
      "ownerID": 1916399,
      "userExternalID": "1916399",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.136053915223,
        "lng": 55.188464025202
      },
      "geography": {
        "lat": 25.136053915223,
        "lng": 55.188464025202
      },
      "purpose": "for-rent",
      "price": 19498,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "1120-Ap-R-1046",
      "permitNumber": null,
      "projectNumber": null,
      "title": "Modern Furnished | Best Amenities | Convenient Location",
      "title_l1": "شقة في بناية لامتارا 3 لامتارا مدينة جميرا ليفينج أم سقیم 1 غرف 19498 درهم - 6382061",
      "externalID": "6382061",
      "slug": "modern-furnished-best-amenities-convenient-location-6382061",
      "slug_l1": "modern-furnished-best-amenities-convenient-location-6382061",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 196,
          "level": 2,
          "externalID": "5656",
          "name": "Umm Suqeim",
          "name_l1": "أم سقیم",
          "slug": "/dubai/umm-suqeim",
          "slug_l1": "/dubai/umm-suqeim",
          "type": "neighbourhood"
        },
        {
          "id": 15942,
          "level": 3,
          "externalID": "12108",
          "name": "Madinat Jumeirah Living",
          "name_l1": "مدينة جميرا ليفينج",
          "slug": "/dubai/umm-suqeim/madinat-jumeirah-living",
          "slug_l1": "/dubai/umm-suqeim/madinat-jumeirah-living",
          "type": "neighbourhood"
        },
        {
          "id": 16009,
          "level": 4,
          "externalID": "12171",
          "name": "Lamtara",
          "name_l1": "لامتارا",
          "slug": "/dubai/umm-suqeim/madinat-jumeirah-living/lamtara",
          "slug_l1": "/dubai/umm-suqeim/madinat-jumeirah-living/lamtara"
        },
        {
          "id": 22454,
          "level": 5,
          "externalID": "14454",
          "name": "Lamtara Building 3",
          "name_l1": "بناية لامتارا 3",
          "slug": "/dubai/umm-suqeim/madinat-jumeirah-living/lamtara/lamtara-building-3",
          "slug_l1": "/dubai/umm-suqeim/madinat-jumeirah-living/lamtara/lamtara-building-3",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1664457129,
      "updatedAt": 1666083083,
      "reactivatedAt": 1664457129,
      "rooms": 1,
      "baths": 1,
      "area": 73.3934016,
      "score": 100,
      "score_l1": 62,
      "coverPhoto": {
        "id": 277534313,
        "externalID": "131074505",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.758559308250597,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/277534313/a860d1923d354094a9a6ec7ffa862658",
        "main": true
      },
      "photoCount": 15,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971507617641",
        "phone": "+97145572402",
        "whatsapp": "971507617641",
        "proxyMobile": "+971527286495",
        "phoneNumbers": [
          "+97145572402"
        ],
        "mobileNumbers": [
          "+971507617641"
        ]
      },
      "contactName": "Shawky Ibrahem",
      "agency": {
        "id": 29536933,
        "objectID": 29536933,
        "name": "Like Home Vacation Homes Rental",
        "name_l1": "مثل تأجير منازل العطلات المنزلية",
        "externalID": "8933",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "825766",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 75770747,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/75770747/3bc86bb51d114bdeafe816268fff2c26"
        },
        "slug": "like-home-vacation-homes-rental-8933",
        "slug_l1": "like-home-vacation-homes-rental-8933",
        "tr": 1,
        "tier": 1,
        "roles": [],
        "active": true,
        "createdAt": "2019-05-26T07:31:53.147487+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "07f9a33",
      "keywords": [
        "مفروش",
        "مول",
        "modern",
        "مفروشة",
        "مودرن",
        "furnished",
        "mall",
        "حديثة",
        "مؤثثة"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1664537400.078745,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1665061973.687088
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 412,
      "randBoostScore_l1": 412,
      "floorPlanID": null,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu-224954877",
        "dldPropertySK": "dld|mea|ae|tabu-224961858"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 412,
      "indyScore_l1": 412,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        277534313,
        283091791,
        277534315,
        277534316,
        277534317,
        283167496,
        283091808,
        277534320,
        279589958,
        283091817,
        277534323,
        278948342,
        277534325,
        277534326,
        277534327
      ],
      "hidePrice": false,
      "locationPurposeTier": 2,
      "objectID": "3697314",
      "_highlightResult": {
        "referenceNumber": {
          "value": "1120-Ap-R-1046",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Modern Furnished | Best Amenities | Convenient Location",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "6382061",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Like Home Vacation Homes Rental",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "modern",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مودرن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "mall",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3194721,
      "ownerID": 1060127,
      "userExternalID": "1060127",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.194762574653,
        "lng": 55.276674628258
      },
      "geography": {
        "lat": 25.194762574653,
        "lng": 55.276674628258
      },
      "purpose": "for-rent",
      "price": 45000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "DP-R-35894",
      "permitNumber": "DOW-AL-ZIYOJ",
      "projectNumber": null,
      "title": "Fountain View 2 Beds Souk Al Bahar",
      "title_l1": "شقة في سوق البحار وسط مدينة دبي 2 غرف 45000 درهم - 5913760",
      "externalID": "5913760",
      "slug": "fountain-view-2-beds-souk-al-bahar-5913760",
      "slug_l1": "fountain-view-2-beds-souk-al-bahar-5913760",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 10,
          "level": 2,
          "externalID": "6901",
          "name": "Downtown Dubai",
          "name_l1": "وسط مدينة دبي",
          "slug": "/dubai/downtown-dubai",
          "slug_l1": "/dubai/downtown-dubai",
          "type": "neighbourhood"
        },
        {
          "id": 1327,
          "level": 3,
          "externalID": "7931",
          "name": "Souk Al Bahar",
          "name_l1": "سوق البحار",
          "slug": "/dubai/downtown-dubai/souk-al-bahar",
          "slug_l1": "/dubai/downtown-dubai/souk-al-bahar",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1650892083,
      "updatedAt": 1666097764,
      "reactivatedAt": 1650892083,
      "rooms": 2,
      "baths": 2,
      "area": 143.81390592,
      "score": 100,
      "score_l1": 62,
      "coverPhoto": {
        "id": 208502195,
        "externalID": "122404607",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.958096100610343,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/208502195/adc3af4965934cf6a34ff49498b3a101",
        "main": true
      },
      "photoCount": 26,
      "videoCount": 0,
      "panoramaCount": 1,
      "phoneNumber": {
        "mobile": "+971509643016",
        "phone": "+97145587789",
        "proxyMobile": "+971525014205",
        "phoneNumbers": [
          "+97145587789"
        ],
        "mobileNumbers": [
          "+971509643016"
        ]
      },
      "contactName": "Driven Holiday Homes",
      "agency": {
        "id": 326,
        "objectID": 326,
        "name": "Driven Holiday Homes",
        "name_l1": "درفن لبيوت العطلات",
        "externalID": "6756",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "730186",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 123148392,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/123148392/db88eef678134cf09a2586918ef5ad08"
        },
        "slug": "driven-holiday-homes-6756",
        "slug_l1": "driven-holiday-homes-6756",
        "tr": 3,
        "tier": 3,
        "roles": [],
        "active": true,
        "createdAt": "2017-12-14T16:29:11.991788+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "cb5d6d4",
      "keywords": [
        "furnished",
        "new",
        "parking",
        "مطبخ",
        "spacious",
        "balcony",
        "ايجار جديد",
        "2 bedroom",
        "غرفتين نوم",
        "مفروش",
        "kitchen",
        "بلكونة",
        "2 غرفة",
        "واسعة",
        "غرفتين",
        "مفروشة",
        "موقف سيارة",
        "مول",
        "مؤثثة",
        "جديدة اول ساكن",
        "جديدة",
        "كبيرة",
        "mall"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1654938401.051155,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663755244.060214
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 379,
      "randBoostScore_l1": 379,
      "floorPlanID": null,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu+ejari-149739",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-186692"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 379,
      "indyScore_l1": 379,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        208502195,
        208502194,
        207295291,
        208502191,
        208502192,
        208502203,
        208502209,
        208502213,
        208502198,
        208502211,
        208502196,
        208502193,
        208502212,
        208502197,
        208502206,
        208502207,
        208502201,
        208502200,
        208502208,
        208502210,
        208502202,
        208502204,
        208502205,
        208502199,
        208502216,
        208502215
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "3194721",
      "_highlightResult": {
        "referenceNumber": {
          "value": "DP-R-35894",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Fountain View 2 Beds Souk Al Bahar",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5913760",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Driven Holiday Homes",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "new",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "spacious",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ايجار جديد",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين نوم",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 غرفة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "واسعة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة اول ساكن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "كبيرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "mall",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 2871882,
      "ownerID": 1135816,
      "userExternalID": "1135816",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.193580472882,
        "lng": 55.27270171282
      },
      "geography": {
        "lat": 25.193580472882,
        "lng": 55.27270171282
      },
      "purpose": "for-rent",
      "price": 34000,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "DOW-RES-80ZHK",
      "permitNumber": "DOW-RES-80ZHK",
      "projectNumber": null,
      "title": "Stunning View,Newly Furnished, 3 Bedroom+maids Apartment",
      "title_l1": "شقة في ذا ريزيدينس 1 ذا ریزیدنسز وسط مدينة دبي 3 غرف 34000 درهم - 5608050",
      "externalID": "5608050",
      "slug": "stunning-view-newly-furnished-3-bedroom-maids-apartment-5608050",
      "slug_l1": "stunning-view-newly-furnished-3-bedroom-maids-apartment-5608050",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 10,
          "level": 2,
          "externalID": "6901",
          "name": "Downtown Dubai",
          "name_l1": "وسط مدينة دبي",
          "slug": "/dubai/downtown-dubai",
          "slug_l1": "/dubai/downtown-dubai",
          "type": "neighbourhood"
        },
        {
          "id": 166,
          "level": 3,
          "externalID": "5142",
          "name": "The Residences",
          "name_l1": "ذا ریزیدنسز",
          "slug": "/dubai/downtown-dubai/the-residences",
          "slug_l1": "/dubai/downtown-dubai/the-residences"
        },
        {
          "id": 874,
          "level": 4,
          "externalID": "8860",
          "name": "The Residence 1",
          "name_l1": "ذا ريزيدينس 1",
          "slug": "/dubai/downtown-dubai/the-residences/the-residence-1",
          "slug_l1": "/dubai/downtown-dubai/the-residences/the-residence-1",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1640267156,
      "updatedAt": 1666078912,
      "reactivatedAt": 1665559186.957795,
      "rooms": 3,
      "baths": 4,
      "area": 193.33122624,
      "score": 100,
      "score_l1": 62,
      "coverPhoto": {
        "id": 179806977,
        "externalID": "115921075",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 5.999984224087624,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/179806977/0eac415e2d6f44ab8bf7369b43d32299",
        "main": true
      },
      "photoCount": 20,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971523027007",
        "phone": "+97143827787",
        "whatsapp": "971523027007",
        "proxyMobile": "+971525716975",
        "phoneNumbers": [
          "+97143827787"
        ],
        "mobileNumbers": [
          "+971523027007"
        ]
      },
      "contactName": "Uzair Ahmed khan",
      "agency": {
        "id": 29621443,
        "objectID": 29621443,
        "name": "Truebleu Vacation Homes Rental",
        "name_l1": "تأجير منازل العطلات Truebleu",
        "externalID": "11043",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "981603",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 168390390,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/168390390/3dda34107e794c5497bcd444b28a6ace"
        },
        "slug": "truebleu-vacation-homes-rental-11043",
        "slug_l1": "truebleu-vacation-homes-rental-11043",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2021-11-23T07:32:57.554833+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "e9601bf",
      "keywords": [
        "ثلاث غرف",
        "مفروش",
        "new",
        "نظيف",
        "جديدة",
        "موقف سيارة",
        "clean",
        "3 bedroom",
        "جديدة اول ساكن",
        "ايجار جديد",
        "واسعة",
        "كبيرة",
        "spacious",
        "ترس",
        "maid",
        "3 غرف جديدة",
        "مفروشة",
        "terrace",
        "furnished",
        "مؤثثة",
        "3 غرف",
        "خادمة",
        "parking",
        "ثلاثه غرفة"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1663062301.418403,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663565443.189441
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 369,
      "randBoostScore_l1": 369,
      "floorPlanID": null,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu+ejari-149747",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-165414"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 369,
      "indyScore_l1": 369,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        179806977,
        175901889,
        175898851,
        179793429,
        177446492,
        175898853,
        182595607,
        177446491,
        182595609,
        179793440,
        177446484,
        175898847,
        179793432,
        182595608,
        179793438,
        177446482,
        179806980,
        175898844,
        179793436,
        175901884
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "2871882",
      "_highlightResult": {
        "referenceNumber": {
          "value": "DOW-RES-80ZHK",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Stunning View,Newly Furnished, 3 Bedroom+maids Apartment",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5608050",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Truebleu Vacation Homes Rental",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "ثلاث غرف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "new",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "نظيف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "clean",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "3 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة اول ساكن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ايجار جديد",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "واسعة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "كبيرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "spacious",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ترس",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "maid",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "3 غرف جديدة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "terrace",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "3 غرف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "خادمة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ثلاثه غرفة",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 2933441,
      "ownerID": 713799,
      "userExternalID": "713799",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.151999,
        "lng": 55.294782
      },
      "geography": {
        "lat": 25.151999,
        "lng": 55.294782
      },
      "purpose": "for-rent",
      "price": 10000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "POLO - 1",
      "permitNumber": "780436",
      "projectNumber": null,
      "title": "MAJLIS VIEW || NEAR TO DUBAI RACECOURSE || MEYDAN || 1BR",
      "title_l1": "شقة فاخرة ومفروشة بشكل رائع من غرفة نوم واحدة - POLO RESIDENCE",
      "externalID": "5669342",
      "slug": "majlis-view-near-to-dubai-racecourse-meydan-1br-5669342",
      "slug_l1": "majlis-view-near-to-dubai-racecourse-meydan-1br-5669342",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 43,
          "level": 2,
          "externalID": "6854",
          "name": "Meydan City",
          "name_l1": "مدينة ميدان",
          "slug": "/dubai/meydan-city",
          "slug_l1": "/dubai/meydan-city",
          "type": "neighbourhood"
        },
        {
          "id": 44,
          "level": 3,
          "externalID": "9388",
          "name": "Meydan Avenue",
          "name_l1": "ميدان أفينيو",
          "slug": "/dubai/meydan-city/meydan-avenue",
          "slug_l1": "/dubai/meydan-city/meydan-avenue",
          "type": "neighbourhood"
        },
        {
          "id": 3962,
          "level": 4,
          "externalID": "8546",
          "name": "Polo Residence",
          "name_l1": "بولو ريزيدنس",
          "slug": "/dubai/meydan-city/meydan-avenue/polo-residence",
          "slug_l1": "/dubai/meydan-city/meydan-avenue/polo-residence",
          "type": "neighbourhood"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1642763256,
      "updatedAt": 1666078926,
      "reactivatedAt": 1642763256,
      "rooms": 1,
      "baths": 2,
      "area": 75.53017152000001,
      "score": 100,
      "score_l1": 100,
      "coverPhoto": {
        "id": 272434128,
        "externalID": "117184185",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 6.003862076289682,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/272434128/cd0f6713ca1f424cbf3474c7bd398b31",
        "main": true
      },
      "photoCount": 8,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971528585543",
        "phone": "+97147707838",
        "whatsapp": "971528585543",
        "proxyMobile": "+971521439205",
        "phoneNumbers": [
          "+97147707838"
        ],
        "mobileNumbers": [
          "+971528585543"
        ]
      },
      "contactName": "BLUE OCEAN HOLIDAY HOMES RENTAL LLC",
      "agency": {
        "id": 29543389,
        "objectID": 29543389,
        "name": "Blue Ocean Holiday Homes Rental LLC",
        "name_l1": "بلو أوشن هوليداي هومز رينتالز ذ",
        "externalID": "9149",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "780436",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 80459086,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/80459086/11c450b8e166465ba5b9b7fb6293f8c4"
        },
        "slug": "blue-ocean-holiday-homes-rental-llc-9149",
        "slug_l1": "blue-ocean-holiday-homes-rental-llc-9149",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2019-09-26T09:41:29.896692+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "d538786",
      "keywords": [
        "furnished",
        "ground",
        "مشتركة",
        "كبيرة",
        "مفروشة",
        "ارضي",
        "فاخرة",
        "shared",
        "ارضية",
        "طابق ارضي",
        "spacious",
        "واسعة",
        "luxury",
        "kitchen",
        "مفروش",
        "مطبخ"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1663679219.116857,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663766167.080272
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 359,
      "randBoostScore_l1": 359,
      "floorPlanID": 30863,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu-17588651",
        "dldPropertySK": "dld|mea|ae|tabu-17588676"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 359,
      "indyScore_l1": 359,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        272434128,
        248078420,
        272434129,
        181336566,
        286809359,
        248078423,
        181336571,
        272549152
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "2933441",
      "_highlightResult": {
        "referenceNumber": {
          "value": "POLO - 1",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "MAJLIS VIEW || NEAR TO DUBAI RACECOURSE || MEYDAN || 1BR",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5669342",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Blue Ocean Holiday Homes Rental LLC",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ground",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مشتركة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "كبيرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ارضي",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "فاخرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "shared",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ارضية",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "طابق ارضي",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "spacious",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "واسعة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "luxury",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 2747124,
      "ownerID": 1060127,
      "userExternalID": "1060127",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.207086,
        "lng": 55.26516
      },
      "geography": {
        "lat": 25.207086,
        "lng": 55.26516
      },
      "purpose": "for-rent",
      "price": 28000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "DP-R-43811",
      "permitNumber": "AL -CIT-YBCK9",
      "projectNumber": null,
      "title": "1 BR Huge Balcony CW B1 Opposite To Mall",
      "title_l1": "شقة في بناية 1 سيتي ووك الوصل 1 غرف 28000 درهم - 5484778",
      "externalID": "5484778",
      "slug": "1-br-huge-balcony-cw-b1-opposite-to-mall-5484778",
      "slug_l1": "1-br-huge-balcony-cw-b1-opposite-to-mall-5484778",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 914,
          "level": 2,
          "externalID": "5654",
          "name": "Al Wasl",
          "name_l1": "الوصل",
          "slug": "/dubai/al-wasl",
          "slug_l1": "/dubai/al-wasl",
          "type": "neighbourhood"
        },
        {
          "id": 24,
          "level": 3,
          "externalID": "8733",
          "name": "City Walk",
          "name_l1": "سيتي ووك",
          "slug": "/dubai/al-wasl/city-walk",
          "slug_l1": "/dubai/al-wasl/city-walk",
          "type": "neighbourhood"
        },
        {
          "id": 16127,
          "level": 4,
          "externalID": "12260",
          "name": "Building 1",
          "name_l1": "بناية 1",
          "slug": "/dubai/al-wasl/city-walk/building-1",
          "slug_l1": "/dubai/al-wasl/city-walk/building-1",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1635423608,
      "updatedAt": 1666078600,
      "reactivatedAt": 1642596334.494949,
      "rooms": 1,
      "baths": 1,
      "area": 149.38808832,
      "score": 100,
      "score_l1": 62,
      "coverPhoto": {
        "id": 170358274,
        "externalID": "113367407",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.632871140084635,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/170358274/3cd8794a8b394e87bfd240e3b9f86c48",
        "main": true
      },
      "photoCount": 20,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971509643016",
        "phone": "+97145587789",
        "proxyMobile": "+971525014205",
        "phoneNumbers": [
          "+97145587789"
        ],
        "mobileNumbers": [
          "+971509643016"
        ]
      },
      "contactName": "Driven Holiday Homes",
      "agency": {
        "id": 326,
        "objectID": 326,
        "name": "Driven Holiday Homes",
        "name_l1": "درفن لبيوت العطلات",
        "externalID": "6756",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "730186",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 123148392,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/123148392/db88eef678134cf09a2586918ef5ad08"
        },
        "slug": "driven-holiday-homes-6756",
        "slug_l1": "driven-holiday-homes-6756",
        "tr": 3,
        "tier": 3,
        "roles": [],
        "active": true,
        "createdAt": "2017-12-14T16:29:11.991788+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "661018d",
      "keywords": [
        "بلكونة",
        "صالة",
        "balcony",
        "kitchen",
        "مطبخ",
        "مفروش",
        "حديثة",
        "غسيل",
        "موقف سيارة",
        "واسعة",
        "open kitchen",
        "كبيرة",
        "مجلس",
        "spacious",
        "modern",
        "مفروشة",
        "guest",
        "furnished",
        "مودرن",
        "lounge",
        "مؤثثة",
        "مول",
        "مطبخ مفتوح",
        "laundry",
        "parking",
        "mall"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1654774736.569319,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663929672.914573
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 349,
      "randBoostScore_l1": 349,
      "floorPlanID": null,
      "furnishingStatus": null,
      "extraFields": {
        "dldBuildingNK": "tabu-31324525",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-31324685"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 349,
      "indyScore_l1": 349,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        170358274,
        170358294,
        170358304,
        170358313,
        170358319,
        170358326,
        170358336,
        170358342,
        170358348,
        170358354,
        170358357,
        170358360,
        170358362,
        170358367,
        170358371,
        170358375,
        170358379,
        170358381,
        170358383,
        170358387
      ],
      "hidePrice": false,
      "locationPurposeTier": 2,
      "objectID": "2747124",
      "_highlightResult": {
        "referenceNumber": {
          "value": "DP-R-43811",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "1 BR Huge Balcony CW B1 Opposite To Mall",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5484778",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Driven Holiday Homes",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "صالة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غسيل",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "واسعة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "open kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "كبيرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مجلس",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "spacious",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "modern",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "guest",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مودرن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "lounge",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ مفتوح",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "laundry",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "mall",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 1754831,
      "ownerID": 792123,
      "userExternalID": "792123",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.089967,
        "lng": 55.148283
      },
      "geography": {
        "lat": 25.089967,
        "lng": 55.148283
      },
      "purpose": "for-rent",
      "price": 22500,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "CROWN1902M",
      "permitNumber": "DUB-MAR-AWHCQ",
      "projectNumber": null,
      "title": "FOR IMMEDIATE BOOKING ! SPLENDID 2BR APARTMENT WITH GREAT VIEWS IN MARINA CROWN",
      "title_l1": "شقة غرفتين وصاله في المارينا كراون مع اطلاله على البحر",
      "externalID": "4595934",
      "slug": "for-immediate-booking-splendid-2br-apartment-with-great-views-in-marina-crown-4595934",
      "slug_l1": "for-immediate-booking-splendid-2br-apartment-with-great-views-in-marina-crown-4595934",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 36,
          "level": 2,
          "externalID": "5003",
          "name": "Dubai Marina",
          "name_l1": "دبي مارينا",
          "slug": "/dubai/dubai-marina",
          "slug_l1": "/dubai/dubai-marina",
          "type": "neighbourhood"
        },
        {
          "id": 221,
          "level": 3,
          "externalID": "5085",
          "name": "Marina Crown",
          "name_l1": "مارينا كراون",
          "slug": "/dubai/dubai-marina/marina-crown",
          "slug_l1": "/dubai/dubai-marina/marina-crown",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1588937124,
      "updatedAt": 1666098350,
      "reactivatedAt": 1588937124,
      "rooms": 2,
      "baths": 3,
      "area": 135.26682624,
      "score": 100,
      "score_l1": 100,
      "coverPhoto": {
        "id": 170789596,
        "externalID": "97216344",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.891749756349721,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/170789596/da846a8b00c74f7fb3ee6ee0fd7a23b6",
        "main": true
      },
      "photoCount": 23,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971589159379",
        "phone": "+97143388004",
        "whatsapp": "971589159379",
        "proxyMobile": "+971588020051",
        "phoneNumbers": [
          "+97143388004"
        ],
        "mobileNumbers": [
          "+971589159379"
        ]
      },
      "contactName": "Ahsan Zain Eddin",
      "agency": {
        "id": 29551757,
        "objectID": 29551757,
        "name": "Your Keys Holiday Homes Rental LLC",
        "name_l1": "يور كيز هوليداي هومز رينتال",
        "externalID": "9290",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "865561",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 83780295,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/83780295/40f206ab5d1c4021832a1ee8ad194b55"
        },
        "slug": "your-keys-holiday-homes-rental-llc-9290",
        "slug_l1": "your-keys-holiday-homes-rental-llc-9290",
        "tr": 3,
        "tier": 3,
        "roles": [],
        "active": true,
        "createdAt": "2019-12-30T06:02:03.954644+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "067d8dc",
      "keywords": [
        "مطبخ",
        "kitchen",
        "with sea view",
        "clean",
        "اسبوعي",
        "غرفتين",
        "balcony",
        "mall",
        "مول",
        "موقف سيارة",
        "على البحر",
        "weekly",
        "نظيف",
        "parking",
        "بلكونة",
        "2 bedroom"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1592295405.72996,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1665991584.840436
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 346,
      "randBoostScore_l1": 346,
      "floorPlanID": 1720,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu+ejari-149276",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-155681"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 346,
      "indyScore_l1": 346,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        170789596,
        170789622,
        170789598,
        170789637,
        170789603,
        170789601,
        170789635,
        170789606,
        170789612,
        170789632,
        170789608,
        170789614,
        170789618,
        170789620,
        170789630,
        170789640,
        170789644,
        170789657,
        170789626,
        170789645,
        170789652,
        170789648,
        170789654
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "1754831",
      "_highlightResult": {
        "referenceNumber": {
          "value": "CROWN1902M",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "FOR IMMEDIATE BOOKING ! SPLENDID 2BR APARTMENT WITH GREAT VIEWS IN MARINA CROWN",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "4595934",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Your Keys Holiday Homes Rental LLC",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "with sea view",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "clean",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "اسبوعي",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "mall",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "على البحر",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "weekly",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "نظيف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3052626,
      "ownerID": 1171362,
      "userExternalID": "1171362",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.187137,
        "lng": 55.275907
      },
      "geography": {
        "lat": 25.187137,
        "lng": 55.275907
      },
      "purpose": "for-rent",
      "price": 18000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "BT1R1006A",
      "permitNumber": "954129",
      "projectNumber": null,
      "title": "Luke Stays - Bellevue Tower 1",
      "title_l1": "شقة في برج بلفيو 1 أبراج بلفيو وسط مدينة دبي 2 غرف 18000 درهم - 5784028",
      "externalID": "5784028",
      "slug": "luke-stays-bellevue-tower-1-5784028",
      "slug_l1": "luke-stays-bellevue-tower-1-5784028",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 10,
          "level": 2,
          "externalID": "6901",
          "name": "Downtown Dubai",
          "name_l1": "وسط مدينة دبي",
          "slug": "/dubai/downtown-dubai",
          "slug_l1": "/dubai/downtown-dubai",
          "type": "neighbourhood"
        },
        {
          "id": 1235,
          "level": 3,
          "externalID": "8732",
          "name": "Bellevue Towers",
          "name_l1": "أبراج بلفيو",
          "slug": "/dubai/downtown-dubai/bellevue-towers",
          "slug_l1": "/dubai/downtown-dubai/bellevue-towers"
        },
        {
          "id": 1417,
          "level": 4,
          "externalID": "10146",
          "name": "Bellevue Tower 1",
          "name_l1": "برج بلفيو 1",
          "slug": "/dubai/downtown-dubai/bellevue-towers/bellevue-tower-1",
          "slug_l1": "/dubai/downtown-dubai/bellevue-towers/bellevue-tower-1",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1646296821,
      "updatedAt": 1665128118,
      "reactivatedAt": 1660939612.835079,
      "rooms": 2,
      "baths": 1,
      "area": 95.13271296,
      "score": 100,
      "score_l1": 62,
      "coverPhoto": {
        "id": 191711245,
        "externalID": "119560061",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 8.10016852606168,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/191711245/dabf59dc35ba436ba6dadbf59eaf43d7",
        "main": true
      },
      "photoCount": 10,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971585087963",
        "whatsapp": "971585087963",
        "proxyMobile": "+971521860516",
        "mobileNumbers": [
          "+971585087963"
        ]
      },
      "contactName": "Luke International Rental Homes",
      "agency": {
        "id": 29617052,
        "objectID": 29617052,
        "name": "Luke International Rental Homes L. L. C.",
        "name_l1": "لوك انترناشيونال رينتال هومز ذ.",
        "externalID": "10898",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "954129",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 156097530,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/156097530/1e8de505bfa84319bfc0b21312de7615"
        },
        "slug": "luke-international-rental-homes-llc-10898",
        "slug_l1": "luke-international-rental-homes-llc-10898",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2021-10-10T13:01:33.604591+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "e846abc",
      "keywords": [
        "families",
        "2 غرفة",
        "نظيف",
        "موقف سيارة",
        "غرفتين نوم",
        "عوائل",
        "balcony",
        "family",
        "مطبخ",
        "مول",
        "parking",
        "مخدوم",
        "مجلس",
        "mall",
        "للعوائل",
        "غرفتين",
        "2 bedroom",
        "بلكونة",
        "clean",
        "kitchen",
        "serviced",
        "guest"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1647091096.231467,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663929344.022061
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 345,
      "randBoostScore_l1": 345,
      "floorPlanID": null,
      "furnishingStatus": "furnished",
      "extraFields": {},
      "type": "property",
      "cityLevelScore": 1,
      "indyScore": 345,
      "indyScore_l1": 345,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        191711245,
        191711248,
        269404679,
        269404680,
        191717795,
        191717798,
        269406981,
        194018933,
        191711249,
        269406982
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "3052626",
      "_highlightResult": {
        "referenceNumber": {
          "value": "BT1R1006A",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Luke Stays - Bellevue Tower 1",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5784028",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Luke International Rental Homes L. L. C.",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "families",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 غرفة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "نظيف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين نوم",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "عوائل",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "family",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مخدوم",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مجلس",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "mall",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "للعوائل",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "clean",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "serviced",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "guest",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3047888,
      "ownerID": 1171362,
      "userExternalID": "1171362",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.197318,
        "lng": 55.270285
      },
      "geography": {
        "lat": 25.197318,
        "lng": 55.270285
      },
      "purpose": "for-rent",
      "price": 11000,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "TLL149",
      "permitNumber": "954129",
      "projectNumber": null,
      "title": "Luke Stays - The Lofts",
      "title_l1": "شقة في لوفتس بوديوم ذا لوفتس وسط مدينة دبي 1 غرف 11000 درهم - 5779604",
      "externalID": "5779604",
      "slug": "luke-stays-the-lofts-5779604",
      "slug_l1": "luke-stays-the-lofts-5779604",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 10,
          "level": 2,
          "externalID": "6901",
          "name": "Downtown Dubai",
          "name_l1": "وسط مدينة دبي",
          "slug": "/dubai/downtown-dubai",
          "slug_l1": "/dubai/downtown-dubai",
          "type": "neighbourhood"
        },
        {
          "id": 174,
          "level": 3,
          "externalID": "5099",
          "name": "The Lofts",
          "name_l1": "ذا لوفتس",
          "slug": "/dubai/downtown-dubai/the-lofts",
          "slug_l1": "/dubai/downtown-dubai/the-lofts"
        },
        {
          "id": 2806,
          "level": 4,
          "externalID": "9898",
          "name": "The Lofts Podium",
          "name_l1": "لوفتس بوديوم",
          "slug": "/dubai/downtown-dubai/the-lofts/the-lofts-podium",
          "slug_l1": "/dubai/downtown-dubai/the-lofts/the-lofts-podium",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1646198821,
      "updatedAt": 1665128421,
      "reactivatedAt": 1660939612.29225,
      "rooms": 1,
      "baths": 1,
      "area": 83.70563904000001,
      "score": 100,
      "score_l1": 65,
      "coverPhoto": {
        "id": 193199482,
        "externalID": "119444373",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 8.587925678770262,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/193199482/442571dd78a5480bb146eeaf67af06e6",
        "main": true
      },
      "photoCount": 9,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971585087963",
        "whatsapp": "971585087963",
        "proxyMobile": "+971521860516",
        "mobileNumbers": [
          "+971585087963"
        ]
      },
      "contactName": "Luke International Rental Homes",
      "agency": {
        "id": 29617052,
        "objectID": 29617052,
        "name": "Luke International Rental Homes L. L. C.",
        "name_l1": "لوك انترناشيونال رينتال هومز ذ.",
        "externalID": "10898",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "954129",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 156097530,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/156097530/1e8de505bfa84319bfc0b21312de7615"
        },
        "slug": "luke-international-rental-homes-llc-10898",
        "slug_l1": "luke-international-rental-homes-llc-10898",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2021-10-10T13:01:33.604591+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "b3afafa",
      "keywords": [
        "clean",
        "parking",
        "موقف سيارة",
        "kitchen",
        "1 bedroom",
        "مطبخ",
        "serviced",
        "مول",
        "للعوائل",
        "مخدوم",
        "guest",
        "families",
        "mall",
        "غرفة واحدة",
        "مجلس",
        "نظيف",
        "family",
        "عوائل"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1647091282.570832,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663582613.841615
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 322,
      "randBoostScore_l1": 322,
      "floorPlanID": 24414,
      "furnishingStatus": "furnished",
      "extraFields": {},
      "type": "property",
      "cityLevelScore": 1,
      "indyScore": 322,
      "indyScore_l1": 322,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        193199482,
        191381209,
        191381210,
        191381211,
        191381214,
        191471686,
        191381216,
        191376255,
        211105249
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "3047888",
      "_highlightResult": {
        "referenceNumber": {
          "value": "TLL149",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Luke Stays - The Lofts",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5779604",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Luke International Rental Homes L. L. C.",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "clean",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "1 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "serviced",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "للعوائل",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مخدوم",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "guest",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "families",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "mall",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفة واحدة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مجلس",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "نظيف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "family",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "عوائل",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 2524518,
      "ownerID": 1044870,
      "userExternalID": "1044870",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.072742839005,
        "lng": 55.131304264069
      },
      "geography": {
        "lat": 25.072742839005,
        "lng": 55.131304264069
      },
      "purpose": "for-rent",
      "price": 24999,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "LI00043",
      "permitNumber": "DUB-SHA-I1S4P",
      "projectNumber": null,
      "title": "STUNNING | 2-BEDROOM APARTMENT| FULLY FURNISHED",
      "title_l1": "شقة في شمس 1 شمس جميرا بيتش ريزيدنس 2 غرف 24999 درهم - 5255751",
      "externalID": "5255751",
      "slug": "stunning-2-bedroom-apartment-fully-furnished-5255751",
      "slug_l1": "stunning-2-bedroom-apartment-fully-furnished-5255751",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 87,
          "level": 2,
          "externalID": "5549",
          "name": "Jumeirah Beach Residence (JBR)",
          "name_l1": "جميرا بيتش ريزيدنس",
          "slug": "/dubai/jumeirah-beach-residence-jbr",
          "slug_l1": "/dubai/jumeirah-beach-residence-jbr",
          "type": "neighbourhood"
        },
        {
          "id": 126,
          "level": 3,
          "externalID": "8441",
          "name": "Shams",
          "name_l1": "شمس",
          "slug": "/dubai/jumeirah-beach-residence-jbr/shams",
          "slug_l1": "/dubai/jumeirah-beach-residence-jbr/shams"
        },
        {
          "id": 127,
          "level": 4,
          "externalID": "5554",
          "name": "Shams 1",
          "name_l1": "شمس 1",
          "slug": "/dubai/jumeirah-beach-residence-jbr/shams/shams-1",
          "slug_l1": "/dubai/jumeirah-beach-residence-jbr/shams/shams-1",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1625651782,
      "updatedAt": 1666078272,
      "reactivatedAt": 1660638710.232603,
      "rooms": 2,
      "baths": 3,
      "area": 127.74168,
      "score": 84,
      "score_l1": 49,
      "coverPhoto": {
        "id": 170864333,
        "externalID": "109183596",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.495802431426455,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/170864333/d3400c084c004fcca6fdaf24ad8e98a3",
        "main": true
      },
      "coverVideo": {
        "externalID": 175283,
        "title": "STUNNING | 2-BDR APARTMENT |",
        "host": "youtube",
        "url": "https://www.youtube.com/watch?v=tNuKujDpUbI",
        "orderIndex": 0
      },
      "photoCount": 9,
      "videoCount": 1,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971545479338",
        "phone": "+97140000000",
        "whatsapp": "971545479338",
        "proxyMobile": "+971522066478",
        "phoneNumbers": [
          "+97140000000"
        ],
        "mobileNumbers": [
          "+971545479338"
        ]
      },
      "contactName": "Reservations",
      "agency": {
        "id": 29601409,
        "objectID": 29601409,
        "name": "Live In Holiday Homes Rental L. L. C",
        "name_l1": "العيش في تأجير منازل العطلات ذ. م. م",
        "externalID": "10556",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "946986",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 106706119,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/106706119/12b6aed4ac604c5da8c81a968f19eac5"
        },
        "slug": "live-in-holiday-homes-rental-llc-10556",
        "slug_l1": "live-in-holiday-homes-rental-llc-10556",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2021-06-07T05:42:52.466011+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "1881735",
      "keywords": [
        "جديدة اول ساكن",
        "جديدة",
        "shared",
        "بلكونة",
        "modern",
        "حديثة",
        "مفروشة",
        "ايجار جديد",
        "مشتركة",
        "كبيرة",
        "kitchen",
        "furnished",
        "شيرنج",
        "مفروش",
        "spacious",
        "مودرن",
        "واسعة",
        "مؤثثة",
        "مطبخ",
        "new",
        "balcony"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1663849870.204819,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663912296.503234
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 156,
      "randBoostScore_l1": 156,
      "floorPlanID": 7859,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu+ejari-149784",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-161682"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 156,
      "indyScore_l1": 156,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        170864333,
        170864339,
        170864343,
        170864347,
        170864349,
        170864352,
        170864354,
        170864357,
        170864358
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "2524518",
      "_highlightResult": {
        "referenceNumber": {
          "value": "LI00043",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "STUNNING | 2-BEDROOM APARTMENT| FULLY FURNISHED",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5255751",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Live In Holiday Homes Rental L. L. C",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "جديدة اول ساكن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "shared",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "modern",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ايجار جديد",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مشتركة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "كبيرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "شيرنج",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "spacious",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مودرن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "واسعة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "new",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 1919925,
      "ownerID": 1060127,
      "userExternalID": "1060127",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.207504,
        "lng": 55.277685
      },
      "geography": {
        "lat": 25.207504,
        "lng": 55.277685
      },
      "purpose": "for-rent",
      "price": 23000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "DP-R-26271",
      "permitNumber": "DIF-IND-5RJK8",
      "projectNumber": null,
      "title": "City View | Spacious 1BR | Index Tower DIFC",
      "title_l1": "شقة في برج إندكس‬ مركز دبي المالي العالمي 1 غرف 23000 درهم - 4711807",
      "externalID": "4711807",
      "slug": "city-view-spacious-1br-index-tower-difc-4711807",
      "slug_l1": "city-view-spacious-1br-index-tower-difc-4711807",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 117,
          "level": 2,
          "externalID": "5374",
          "name": "DIFC",
          "name_l1": "مركز دبي المالي العالمي",
          "slug": "/dubai/difc",
          "slug_l1": "/dubai/difc",
          "type": "neighbourhood"
        },
        {
          "id": 3262,
          "level": 3,
          "externalID": "5954",
          "name": "Index Tower",
          "name_l1": "برج إندكس‬",
          "slug": "/dubai/difc/index-tower",
          "slug_l1": "/dubai/difc/index-tower",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1596457412,
      "updatedAt": 1666096924,
      "reactivatedAt": 1642597010.781992,
      "rooms": 1,
      "baths": 1,
      "area": 82.12628736,
      "score": 80,
      "score_l1": 42,
      "coverPhoto": {
        "id": 170359473,
        "externalID": "109231670",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.950501017589461,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/170359473/4aae2828c81545e6a660f86e3b39e394",
        "main": true
      },
      "photoCount": 20,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971509643016",
        "phone": "+97145587789",
        "proxyMobile": "+971525014205",
        "phoneNumbers": [
          "+97145587789"
        ],
        "mobileNumbers": [
          "+971509643016"
        ]
      },
      "contactName": "Driven Holiday Homes",
      "agency": {
        "id": 326,
        "objectID": 326,
        "name": "Driven Holiday Homes",
        "name_l1": "درفن لبيوت العطلات",
        "externalID": "6756",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "730186",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 123148392,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/123148392/db88eef678134cf09a2586918ef5ad08"
        },
        "slug": "driven-holiday-homes-6756",
        "slug_l1": "driven-holiday-homes-6756",
        "tr": 3,
        "tier": 3,
        "roles": [],
        "active": true,
        "createdAt": "2017-12-14T16:29:11.991788+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "61ec53d",
      "keywords": [
        "kitchen",
        "floor",
        "furnished",
        "كبيرة",
        "مؤثثة",
        "parking",
        "دور",
        "مفروش",
        "مفروشة",
        "موقف سيارة",
        "مطبخ",
        "spacious",
        "واسعة"
      ],
      "isVerified": true,
      "verification": {
        "updatedAt": 1615975356.329494,
        "eligible": true,
        "status": "verified",
        "verifiedAt": 1663912839.270819
      },
      "verifiedScore": 0,
      "completionStatus": "completed",
      "randBoostScore": 56,
      "randBoostScore_l1": 56,
      "floorPlanID": null,
      "furnishingStatus": "furnished",
      "extraFields": {},
      "type": "property",
      "cityLevelScore": 1,
      "indyScore": 56,
      "indyScore_l1": 56,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        170359473,
        170359480,
        170359483,
        170359488,
        170359494,
        170359606,
        170359499,
        170359515,
        170359600,
        170359573,
        170359578,
        170359564,
        170359583,
        170359554,
        170359569,
        170359557,
        170359589,
        170359501,
        170359594,
        170359519
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "1919925",
      "_highlightResult": {
        "referenceNumber": {
          "value": "DP-R-26271",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "City View | Spacious 1BR | Index Tower DIFC",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "4711807",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Driven Holiday Homes",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "floor",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "كبيرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "دور",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "spacious",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "واسعة",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 2217322,
      "ownerID": 972096,
      "userExternalID": "972096",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.11521,
        "lng": 55.248445
      },
      "geography": {
        "lat": 25.11521,
        "lng": 55.248445
      },
      "purpose": "for-rent",
      "price": 17000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "10223-KyeSuo",
      "permitNumber": null,
      "projectNumber": null,
      "title": "Luxury 1 BHK | Al Khalil Road access | Dubai Hills | All Inclusive",
      "title_l1": "شقة في بارك هايتس 2 بارك هايتس دبي هيلز استيت 1 غرف 17000 درهم - 4950165",
      "externalID": "4950165",
      "slug": "luxury-1-bhk-al-khalil-road-access-dubai-hills-all-inclusive-4950165",
      "slug_l1": "luxury-1-bhk-al-khalil-road-access-dubai-hills-all-inclusive-4950165",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 53,
          "level": 2,
          "externalID": "8288",
          "name": "Dubai Hills Estate",
          "name_l1": "دبي هيلز استيت",
          "slug": "/dubai/dubai-hills-estate",
          "slug_l1": "/dubai/dubai-hills-estate",
          "type": "neighbourhood"
        },
        {
          "id": 108,
          "level": 3,
          "externalID": "8520",
          "name": "Park Heights",
          "name_l1": "بارك هايتس",
          "slug": "/dubai/dubai-hills-estate/park-heights",
          "slug_l1": "/dubai/dubai-hills-estate/park-heights",
          "type": "neighbourhood"
        },
        {
          "id": 3201,
          "level": 4,
          "externalID": "9230",
          "name": "Park Heights 2",
          "name_l1": "بارك هايتس 2",
          "slug": "/dubai/dubai-hills-estate/park-heights/park-heights-2",
          "slug_l1": "/dubai/dubai-hills-estate/park-heights/park-heights-2",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1610290920,
      "updatedAt": 1666083008,
      "reactivatedAt": 1657707806.775299,
      "rooms": 1,
      "baths": 1,
      "area": 59.9224608,
      "score": 100,
      "score_l1": 65,
      "coverPhoto": {
        "id": 268297362,
        "externalID": "116290964",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.814501350801848,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/268297362/aec61125e4494f128466fc1028ade9d6",
        "main": true
      },
      "photoCount": 17,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971585410707",
        "phone": "+97142440770",
        "whatsapp": "971585410707",
        "proxyMobile": "+971524891084",
        "phoneNumbers": [
          "+97142440770"
        ],
        "mobileNumbers": [
          "+971585410707"
        ]
      },
      "contactName": "Apalhomes",
      "agency": {
        "id": 29590451,
        "objectID": 29590451,
        "name": "APAL Holiday Homes Rental LLC",
        "name_l1": "أبال هوليدي هومز رينتال ذ م م",
        "externalID": "10223",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "893318",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 100185734,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/100185734/1c10b2d6b81540efa01d3c28c91d7bf6"
        },
        "slug": "apal-holiday-homes-rental-llc-10223",
        "slug_l1": "apal-holiday-homes-rental-llc-10223",
        "tr": 3,
        "tier": 3,
        "roles": [],
        "active": true,
        "createdAt": "2021-01-10T06:35:00.884714+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "43b14a3",
      "keywords": [
        "luxury",
        "فاخرة"
      ],
      "isVerified": false,
      "verification": {
        "updatedAt": 1618827499.624453,
        "eligible": true,
        "status": "unverified",
        "verifiedAt": null
      },
      "verifiedScore": 1,
      "completionStatus": "completed",
      "randBoostScore": 898,
      "randBoostScore_l1": 898,
      "floorPlanID": 7054,
      "furnishingStatus": "furnished",
      "extraFields": {},
      "type": "property",
      "cityLevelScore": 1,
      "indyScore": 898,
      "indyScore_l1": 898,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        268297362,
        177570751,
        178998737,
        178998738,
        178998739,
        178998740,
        187239446,
        178998742,
        184264637,
        268297364,
        187239448,
        178998746,
        170833053,
        170833054,
        170833057,
        170833059,
        170833052
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "2217322",
      "_highlightResult": {
        "referenceNumber": {
          "value": "10223-KyeSuo",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Luxury 1 BHK | Al Khalil Road access | Dubai Hills | All Inclusive",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "4950165",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "APAL Holiday Homes Rental LLC",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "luxury",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "فاخرة",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 1396701,
      "ownerID": 1324731,
      "userExternalID": "1324731",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.076601,
        "lng": 55.14552
      },
      "geography": {
        "lat": 25.076601,
        "lng": 55.14552
      },
      "purpose": "for-rent",
      "price": 16500,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "1175-Ap-R-0030",
      "permitNumber": "1711012737",
      "projectNumber": null,
      "title": "Walk to metro | Spacious | Lowest Prince",
      "title_l1": "شقة في برج سابا 2 مجمع Q أبراج بحيرات الجميرا 2 غرف 16500 درهم - 4242120",
      "externalID": "4242120",
      "slug": "walk-to-metro-spacious-lowest-prince-4242120",
      "slug_l1": "walk-to-metro-spacious-lowest-prince-4242120",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 12,
          "level": 2,
          "externalID": "5152",
          "name": "Jumeirah Lake Towers (JLT)",
          "name_l1": "أبراج بحيرات الجميرا",
          "slug": "/dubai/jumeirah-lake-towers-jlt",
          "slug_l1": "/dubai/jumeirah-lake-towers-jlt",
          "type": "neighbourhood"
        },
        {
          "id": 22398,
          "level": 3,
          "externalID": "14404",
          "name": "JLT Cluster Q",
          "name_l1": "مجمع Q",
          "slug": "/dubai/jumeirah-lake-towers-jlt/jlt-cluster-q",
          "slug_l1": "/dubai/jumeirah-lake-towers-jlt/jlt-cluster-q"
        },
        {
          "id": 18,
          "level": 4,
          "externalID": "5198",
          "name": "Saba Tower 2",
          "name_l1": "برج سابا 2",
          "slug": "/dubai/jumeirah-lake-towers-jlt/jlt-cluster-q/saba-tower-2",
          "slug_l1": "/dubai/jumeirah-lake-towers-jlt/jlt-cluster-q/saba-tower-2",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1566125310,
      "updatedAt": 1666083952,
      "reactivatedAt": 1666077071.860457,
      "rooms": 2,
      "baths": 2,
      "area": 137.40359616,
      "score": 91,
      "score_l1": 56,
      "coverPhoto": {
        "id": 287429477,
        "externalID": "132065140",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.780161642874997,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/287429477/622548f369f248c8bbd061ecfcd30008",
        "main": true
      },
      "photoCount": 22,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971588917066",
        "phone": "+971581085688",
        "whatsapp": "971588917066",
        "proxyMobile": "+971526774687",
        "phoneNumbers": [
          "+971581085688"
        ],
        "mobileNumbers": [
          "+971588917066"
        ]
      },
      "contactName": "Melissa Mendoza",
      "agency": {
        "id": 29538752,
        "objectID": 29538752,
        "name": "Raine & Horne Holiday Homes",
        "name_l1": "رين وهورن عطلة المنازل",
        "externalID": "9003",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "714434",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 77277398,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/77277398/bba9db31bf704e6d8122a058b50a87d3"
        },
        "slug": "raine-horne-holiday-homes-9003",
        "slug_l1": "raine-horne-holiday-homes-9003",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2019-07-02T11:53:17.175971+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "c3ed71e",
      "keywords": [
        "واسعة",
        "furnished",
        "مخدوم",
        "kitchen",
        "مفروش",
        "يومي",
        "weekly",
        "serviced",
        "مفروشة",
        "spacious",
        "كبيرة",
        "موقف سيارة",
        "مطبخ",
        "اسبوعي",
        "parking",
        "daily",
        "مؤثثة"
      ],
      "isVerified": false,
      "verification": {
        "updatedAt": 1578118056.176293,
        "eligible": true,
        "status": "unverified",
        "verifiedAt": null
      },
      "verifiedScore": 1,
      "completionStatus": "completed",
      "randBoostScore": 860,
      "randBoostScore_l1": 860,
      "floorPlanID": null,
      "furnishingStatus": "furnished",
      "extraFields": {},
      "type": "property",
      "cityLevelScore": 1,
      "indyScore": 860,
      "indyScore_l1": 860,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        287429477,
        287429478,
        287381923,
        287429479,
        287429480,
        287429481,
        287429482,
        170773685,
        287429483,
        287429484,
        287429487,
        287429488,
        287429490,
        287381934,
        170773709,
        287429491,
        287429492,
        287429493,
        287429494,
        287429495,
        287429496,
        287519127
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "1396701",
      "_highlightResult": {
        "referenceNumber": {
          "value": "1175-Ap-R-0030",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Walk to metro | Spacious | Lowest Prince",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "4242120",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Raine & Horne Holiday Homes",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "واسعة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مخدوم",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "يومي",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "weekly",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "serviced",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "spacious",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "كبيرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "اسبوعي",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "daily",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 2617697,
      "ownerID": 1060127,
      "userExternalID": "1060127",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.076868,
        "lng": 55.134292
      },
      "geography": {
        "lat": 25.076868,
        "lng": 55.134292
      },
      "purpose": "for-rent",
      "price": 21000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "DP-R-43457",
      "permitNumber": "JUM-RIM-1BRGW",
      "projectNumber": null,
      "title": "3 Minute Walk to The Beach, Huge 1Bed Rimal 3",
      "title_l1": "شقة في رمال 3 رمال جميرا بيتش ريزيدنس 1 غرف 21000 درهم - 5353500",
      "externalID": "5353500",
      "slug": "3-minute-walk-to-the-beach-huge-1bed-rimal-3-5353500",
      "slug_l1": "3-minute-walk-to-the-beach-huge-1bed-rimal-3-5353500",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 87,
          "level": 2,
          "externalID": "5549",
          "name": "Jumeirah Beach Residence (JBR)",
          "name_l1": "جميرا بيتش ريزيدنس",
          "slug": "/dubai/jumeirah-beach-residence-jbr",
          "slug_l1": "/dubai/jumeirah-beach-residence-jbr",
          "type": "neighbourhood"
        },
        {
          "id": 212,
          "level": 3,
          "externalID": "8439",
          "name": "Rimal",
          "name_l1": "رمال",
          "slug": "/dubai/jumeirah-beach-residence-jbr/rimal",
          "slug_l1": "/dubai/jumeirah-beach-residence-jbr/rimal"
        },
        {
          "id": 213,
          "level": 4,
          "externalID": "5566",
          "name": "Rimal 3",
          "name_l1": "رمال 3",
          "slug": "/dubai/jumeirah-beach-residence-jbr/rimal/rimal-3",
          "slug_l1": "/dubai/jumeirah-beach-residence-jbr/rimal/rimal-3",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1630135267,
      "updatedAt": 1666100524,
      "reactivatedAt": 1642597010.346878,
      "rooms": 1,
      "baths": 1,
      "area": 107.58172032,
      "score": 100,
      "score_l1": 62,
      "coverPhoto": {
        "id": 170361173,
        "externalID": "110930895",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.456304787288353,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/170361173/c5873ab9131045ab8ffe3928b77363b2",
        "main": true
      },
      "photoCount": 30,
      "videoCount": 0,
      "panoramaCount": 1,
      "phoneNumber": {
        "mobile": "+971509643016",
        "phone": "+97145587789",
        "proxyMobile": "+971525014205",
        "phoneNumbers": [
          "+97145587789"
        ],
        "mobileNumbers": [
          "+971509643016"
        ]
      },
      "contactName": "Driven Holiday Homes",
      "agency": {
        "id": 326,
        "objectID": 326,
        "name": "Driven Holiday Homes",
        "name_l1": "درفن لبيوت العطلات",
        "externalID": "6756",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "730186",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 123148392,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/123148392/db88eef678134cf09a2586918ef5ad08"
        },
        "slug": "driven-holiday-homes-6756",
        "slug_l1": "driven-holiday-homes-6756",
        "tr": 3,
        "tier": 3,
        "roles": [],
        "active": true,
        "createdAt": "2017-12-14T16:29:11.991788+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "fc04e15",
      "keywords": [
        "مفروشة",
        "مفروش",
        "مجلس",
        "balcony",
        "مؤثثة",
        "modern",
        "حديثة",
        "مطبخ",
        "بلكونة",
        "مودرن",
        "guest",
        "kitchen",
        "parking",
        "موقف سيارة",
        "furnished"
      ],
      "isVerified": false,
      "verification": {
        "updatedAt": 1654776145.032845,
        "eligible": true,
        "status": "unverified",
        "verifiedAt": null
      },
      "verifiedScore": 1,
      "completionStatus": "completed",
      "randBoostScore": 842,
      "randBoostScore_l1": 842,
      "floorPlanID": null,
      "furnishingStatus": null,
      "extraFields": {
        "dldBuildingNK": "tabu+ejari-149780",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-154820"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 842,
      "indyScore_l1": 842,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        170361173,
        170361116,
        170361125,
        170361107,
        170361097,
        170361130,
        170361136,
        170361143,
        170361151,
        170361157,
        170361180,
        170361161,
        170361198,
        170361164,
        170361186,
        170361194,
        170361206,
        170361214,
        170361220,
        170361224,
        170361232,
        170361238,
        170361243,
        170361250,
        170361253,
        170361257,
        170361270,
        170361271,
        170361275,
        170361278
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "2617697",
      "_highlightResult": {
        "referenceNumber": {
          "value": "DP-R-43457",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "3 Minute Walk to The Beach, Huge 1Bed Rimal 3",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5353500",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Driven Holiday Homes",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مجلس",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "modern",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مودرن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "guest",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3644983,
      "ownerID": 1864315,
      "userExternalID": "1864315",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.086879894236,
        "lng": 55.147474408041
      },
      "geography": {
        "lat": 25.086879894236,
        "lng": 55.147474408041
      },
      "purpose": "for-rent",
      "price": 30000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "3607-Ap-R-0028",
      "permitNumber": "1041964",
      "projectNumber": null,
      "title": "Spacious Apartment in the heart of Dubai Marina",
      "title_l1": "شقة في بوابة المارينا دبي مارينا 2 غرف 30000 درهم - 6340154",
      "externalID": "6340154",
      "slug": "spacious-apartment-in-the-heart-of-dubai-marina-6340154",
      "slug_l1": "spacious-apartment-in-the-heart-of-dubai-marina-6340154",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 36,
          "level": 2,
          "externalID": "5003",
          "name": "Dubai Marina",
          "name_l1": "دبي مارينا",
          "slug": "/dubai/dubai-marina",
          "slug_l1": "/dubai/dubai-marina",
          "type": "neighbourhood"
        },
        {
          "id": 772,
          "level": 3,
          "externalID": "8500",
          "name": "Marina Gate",
          "name_l1": "بوابة المارينا",
          "slug": "/dubai/dubai-marina/marina-gate",
          "slug_l1": "/dubai/dubai-marina/marina-gate"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1663325072,
      "updatedAt": 1666082444,
      "reactivatedAt": 1663325072,
      "rooms": 2,
      "baths": 2,
      "area": 117.70815168,
      "score": 100,
      "score_l1": 62,
      "coverPhoto": {
        "id": 271503498,
        "externalID": "130361016",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.68320284815388,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/271503498/4c5ac2e13be542ae84a991c5e4b0237f",
        "main": true
      },
      "photoCount": 25,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971588442184",
        "phone": "+971588442184",
        "whatsapp": "971588442184",
        "proxyMobile": "+971588576934",
        "phoneNumbers": [
          "+971588442184"
        ],
        "mobileNumbers": [
          "+971588442184"
        ]
      },
      "contactName": "Mint Stay Holiday Homes Rental LLC",
      "agency": {
        "id": 29640781,
        "objectID": 29640781,
        "name": "Mint Stay Homes Rental L. L. C.",
        "name_l1": "مينت ستاي لتأجير المنازل ذ.",
        "externalID": "100446",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "1041964",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 217218876,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/217218876/8158288d392241cfab04366dbda515aa"
        },
        "slug": "mint-stay-homes-rental-llc-100446",
        "slug_l1": "mint-stay-homes-rental-llc-100446",
        "tr": 4,
        "tier": 4,
        "roles": [],
        "active": true,
        "createdAt": "2022-05-24T11:28:10.596538+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "dc201d5",
      "keywords": [
        "guest",
        "مودرن",
        "kitchen",
        "كبيرة",
        "مطبخ",
        "مفروشة",
        "modern",
        "مفروش",
        "furnished",
        "spacious",
        "حديثة",
        "موقف سيارة",
        "مجلس",
        "balcony",
        "parking",
        "مؤثثة",
        "بلكونة",
        "واسعة"
      ],
      "isVerified": false,
      "verification": {
        "updatedAt": 1664869212.251258,
        "eligible": true,
        "status": "unverified",
        "verifiedAt": null
      },
      "verifiedScore": 1,
      "completionStatus": "completed",
      "randBoostScore": 815,
      "randBoostScore_l1": 815,
      "floorPlanID": null,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu-18016154",
        "dldPropertySK": "dld|mea|ae|tabu+ejari-18016205"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 815,
      "indyScore_l1": 815,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        271503498,
        271503495,
        271503501,
        271503504,
        271503506,
        271503508,
        271503510,
        271503511,
        271503512,
        271503513,
        271503514,
        271503515,
        273818387,
        275721797,
        275721798,
        273818390,
        271503525,
        271503528,
        271503530,
        273818395,
        275721802,
        275721803,
        277182535,
        277182536,
        279361342
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "3644983",
      "_highlightResult": {
        "referenceNumber": {
          "value": "3607-Ap-R-0028",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Spacious Apartment in the heart of Dubai Marina",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "6340154",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "Mint Stay Homes Rental L. L. C.",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "guest",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مودرن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "kitchen",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "كبيرة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطبخ",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "modern",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "spacious",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "موقف سيارة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مجلس",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "balcony",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "parking",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "بلكونة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "واسعة",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3309676,
      "ownerID": 1109415,
      "userExternalID": "1109415",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.20630017458,
        "lng": 55.344507694244
      },
      "geography": {
        "lat": 25.20630017458,
        "lng": 55.344507694244
      },
      "purpose": "for-rent",
      "price": 11000,
      "product": "superhot",
      "productLabel": "default",
      "productScore": 0,
      "rentFrequency": "monthly",
      "referenceNumber": "AZCOHH1BR71121606",
      "permitNumber": null,
      "projectNumber": null,
      "title": "Brand New | Fully Furnished 1 BR Apartment",
      "title_l1": "علامة تجارية جديدة | شقة مفروشة بالكامل 1 غرف نوم",
      "externalID": "6023506",
      "slug": "brand-new-fully-furnished-1-br-apartment-6023506",
      "slug_l1": "brand-new-fully-furnished-1-br-apartment-6023506",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 241,
          "level": 2,
          "externalID": "5539",
          "name": "The Lagoons",
          "name_l1": "ذا لاجونز",
          "slug": "/dubai/the-lagoons",
          "slug_l1": "/dubai/the-lagoons",
          "type": "neighbourhood"
        },
        {
          "id": 242,
          "level": 3,
          "externalID": "8617",
          "name": "Dubai Creek Harbour",
          "name_l1": "مرسى خور دبي",
          "slug": "/dubai/the-lagoons/dubai-creek-harbour",
          "slug_l1": "/dubai/the-lagoons/dubai-creek-harbour",
          "type": "neighbourhood"
        },
        {
          "id": 1243,
          "level": 4,
          "externalID": "11198",
          "name": "Harbour Views",
          "name_l1": "هاربور فيوز",
          "slug": "/dubai/the-lagoons/dubai-creek-harbour/harbour-views",
          "slug_l1": "/dubai/the-lagoons/dubai-creek-harbour/harbour-views"
        },
        {
          "id": 1244,
          "level": 5,
          "externalID": "8618",
          "name": "Harbour Views 1",
          "name_l1": "هاربور فيوز 1",
          "slug": "/dubai/the-lagoons/dubai-creek-harbour/harbour-views/harbour-views-1",
          "slug_l1": "/dubai/the-lagoons/dubai-creek-harbour/harbour-views/harbour-views-1",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1654757719,
      "updatedAt": 1666079907,
      "reactivatedAt": 1663229259.146768,
      "rooms": 1,
      "baths": 2,
      "area": 65.9611584,
      "score": 100,
      "score_l1": 100,
      "coverPhoto": {
        "id": 249277922,
        "externalID": "124207377",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 9.345483929135753,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/249277922/374d1bf0a10f4672957dc0a8d3097eae",
        "main": true
      },
      "coverVideo": {
        "externalID": 394767,
        "title": "Dubai Creek Harbour, The Lagoons, Holiday Homes!",
        "host": "youtube",
        "url": "https://youtu.be/seHNHj8NhvY",
        "orderIndex": 0
      },
      "photoCount": 11,
      "videoCount": 1,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971581036832",
        "phone": "+97145587741",
        "whatsapp": "971581036832",
        "phoneNumbers": [
          "+97145587741"
        ],
        "mobileNumbers": [
          "+971581036832"
        ]
      },
      "contactName": "Azco Holiday Homes",
      "agency": {
        "id": 29617285,
        "objectID": 29617285,
        "name": "AZCO Holiday Homes Rental LLC",
        "name_l1": "أزكو هوليداى هومز رينتال ذ م م",
        "externalID": "10905",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "961172",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 156765620,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/156765620/4597f663c8794a24a9c28b1a9a3959d8"
        },
        "slug": "azco-holiday-homes-rental-llc-10905",
        "slug_l1": "azco-holiday-homes-rental-llc-10905",
        "tr": 1,
        "tier": 1,
        "roles": [],
        "active": true,
        "createdAt": "2021-10-12T06:46:18.042512+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "6525f77",
      "keywords": [
        "جديدة",
        "new",
        "حديثة",
        "اول ساكن",
        "ثلاث غرف",
        "brand new",
        "جديدة اول ساكن",
        "garden",
        "modern",
        "مفروشة",
        "ايجار جديد",
        "حديقة",
        "ساكن اول",
        "مودرن",
        "مفروش",
        "furnished",
        "2 bedroom",
        "clean",
        "مؤثثة",
        "نظيف",
        "غرفتين",
        "3 bedroom"
      ],
      "isVerified": false,
      "verification": {
        "updatedAt": 1656439595.102945,
        "eligible": true,
        "status": "unverified",
        "verifiedAt": null
      },
      "verifiedScore": 1,
      "completionStatus": "completed",
      "randBoostScore": 811,
      "randBoostScore_l1": 811,
      "floorPlanID": 11585,
      "furnishingStatus": "furnished",
      "extraFields": {
        "dldBuildingNK": "tabu-27670833",
        "dldPropertySK": "dld|mea|ae|tabu-27671301"
      },
      "type": "property",
      "hasTransactionHistory": true,
      "cityLevelScore": 1,
      "indyScore": 811,
      "indyScore_l1": 811,
      "hasMatchingFloorPlans": false,
      "photoIDs": [
        249277922,
        230062022,
        246736431,
        232253755,
        257549009,
        224043567,
        232253758,
        231404629,
        235811673,
        262585609,
        257549012
      ],
      "hidePrice": false,
      "locationPurposeTier": 2,
      "objectID": "3309676",
      "_highlightResult": {
        "referenceNumber": {
          "value": "AZCOHH1BR71121606",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Brand New | Fully Furnished 1 BR Apartment",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "6023506",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "AZCO Holiday Homes Rental LLC",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "جديدة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "new",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "اول ساكن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ثلاث غرف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "brand new",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "جديدة اول ساكن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "garden",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "modern",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروشة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ايجار جديد",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديقة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "ساكن اول",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مودرن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مفروش",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "furnished",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "2 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "clean",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مؤثثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "نظيف",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "غرفتين",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "3 bedroom",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    },
    {
      "id": 3201865,
      "ownerID": 972096,
      "userExternalID": "972096",
      "sourceID": 1,
      "state": "active",
      "_geoloc": {
        "lat": 25.099519,
        "lng": 55.244235
      },
      "geography": {
        "lat": 25.099519,
        "lng": 55.244235
      },
      "purpose": "for-rent",
      "price": 17000,
      "product": "hot",
      "productLabel": "default",
      "productScore": 1,
      "rentFrequency": "monthly",
      "referenceNumber": "10223-n7dJeC",
      "permitNumber": null,
      "projectNumber": null,
      "title": "Amazing Apartment | Modern 1 BR Apartment | Dubai Hills | Collective I",
      "title_l1": "شقة في كولكتيف دبي هيلز استيت 1 غرف 17000 درهم - 5921019",
      "externalID": "5921019",
      "slug": "amazing-apartment-modern-1-br-apartment-dubai-hills-collective-i-5921019",
      "slug_l1": "amazing-apartment-modern-1-br-apartment-dubai-hills-collective-i-5921019",
      "location": [
        {
          "id": 1,
          "level": 0,
          "externalID": "5001",
          "name": "UAE",
          "name_l1": "الإمارات",
          "slug": "/uae",
          "slug_l1": "/uae"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "5002",
          "name": "Dubai",
          "name_l1": "دبي",
          "slug": "/dubai",
          "slug_l1": "/dubai"
        },
        {
          "id": 53,
          "level": 2,
          "externalID": "8288",
          "name": "Dubai Hills Estate",
          "name_l1": "دبي هيلز استيت",
          "slug": "/dubai/dubai-hills-estate",
          "slug_l1": "/dubai/dubai-hills-estate",
          "type": "neighbourhood"
        },
        {
          "id": 4967,
          "level": 3,
          "externalID": "11925",
          "name": "Collective",
          "name_l1": "كولكتيف",
          "slug": "/dubai/dubai-hills-estate/collective",
          "slug_l1": "/dubai/dubai-hills-estate/collective",
          "type": "condo-building"
        }
      ],
      "category": [
        {
          "id": 1,
          "level": 0,
          "externalID": "1",
          "name": "Residential",
          "name_l1": "سكني",
          "slug": "residential",
          "slug_l1": "residential",
          "nameSingular": "Residential",
          "nameSingular_l1": "سكني"
        },
        {
          "id": 2,
          "level": 1,
          "externalID": "4",
          "name": "Apartments",
          "name_l1": "شقق",
          "slug": "apartments",
          "slug_l1": "apartments",
          "nameSingular": "Apartment",
          "nameSingular_l1": "شقة"
        }
      ],
      "createdAt": 1651157067,
      "updatedAt": 1666082863,
      "reactivatedAt": 1651157067,
      "rooms": 1,
      "baths": 1,
      "area": 44.22184704,
      "score": 100,
      "score_l1": 65,
      "coverPhoto": {
        "id": 235936923,
        "externalID": "122409648",
        "title": null,
        "orderIndex": 0,
        "nimaScore": 8.5580545441953,
        "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/235936923/cadf9ae5c07543259604299c0a3be81e",
        "main": true
      },
      "photoCount": 17,
      "videoCount": 0,
      "panoramaCount": 0,
      "phoneNumber": {
        "mobile": "+971585410707",
        "phone": "+97142440770",
        "whatsapp": "971585410707",
        "proxyMobile": "+971524891084",
        "phoneNumbers": [
          "+97142440770"
        ],
        "mobileNumbers": [
          "+971585410707"
        ]
      },
      "contactName": "Apalhomes",
      "agency": {
        "id": 29590451,
        "objectID": 29590451,
        "name": "APAL Holiday Homes Rental LLC",
        "name_l1": "أبال هوليدي هومز رينتال ذ م م",
        "externalID": "10223",
        "product": "premium",
        "productScore": 2,
        "licenses": [
          {
            "number": "893318",
            "authority": "DED"
          }
        ],
        "logo": {
          "id": 100185734,
          "url": "https://bayut-production.s3.eu-central-1.amazonaws.com/image/100185734/1c10b2d6b81540efa01d3c28c91d7bf6"
        },
        "slug": "apal-holiday-homes-rental-llc-10223",
        "slug_l1": "apal-holiday-homes-rental-llc-10223",
        "tr": 3,
        "tier": 3,
        "roles": [],
        "active": true,
        "createdAt": "2021-01-10T06:35:00.884714+00:00",
        "commercialNumber": null,
        "shortNumber": null
      },
      "hash": "cdb673d",
      "keywords": [
        "modern",
        "حديثة",
        "مطار",
        "مودرن",
        "airport"
      ],
      "isVerified": false,
      "verification": {
        "updatedAt": 1653656620.095327,
        "eligible": true,
        "status": "unverified",
        "verifiedAt": 1657609425.905619
      },
      "verifiedScore": 1,
      "completionStatus": "completed",
      "randBoostScore": 806,
      "randBoostScore_l1": 806,
      "floorPlanID": 20901,
      "furnishingStatus": "furnished",
      "extraFields": {},
      "type": "property",
      "cityLevelScore": 1,
      "indyScore": 806,
      "indyScore_l1": 806,
      "hasMatchingFloorPlans": true,
      "photoIDs": [
        235936923,
        248656640,
        209385018,
        209385019,
        236218570,
        236218571,
        252955011,
        239572609,
        249057245,
        236218575,
        209385026,
        268283087,
        209385028,
        234711190,
        208524690,
        239572615,
        248656645
      ],
      "hidePrice": false,
      "locationPurposeTier": 1,
      "objectID": "3201865",
      "_highlightResult": {
        "referenceNumber": {
          "value": "10223-n7dJeC",
          "matchLevel": "none",
          "matchedWords": []
        },
        "title": {
          "value": "Amazing Apartment | Modern 1 BR Apartment | Dubai Hills | Collective I",
          "matchLevel": "none",
          "matchedWords": []
        },
        "externalID": {
          "value": "5921019",
          "matchLevel": "none",
          "matchedWords": []
        },
        "agency": {
          "name": {
            "value": "APAL Holiday Homes Rental LLC",
            "matchLevel": "none",
            "matchedWords": []
          }
        },
        "keywords": [
          {
            "value": "modern",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "حديثة",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مطار",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "مودرن",
            "matchLevel": "none",
            "matchedWords": []
          },
          {
            "value": "airport",
            "matchLevel": "none",
            "matchedWords": []
          }
        ]
      }
    }
  ],
  "nbHits": 2318,
  "page": 0,
  "nbPages": 93,
  "hitsPerPage": 25,
  "exhaustiveNbHits": true,
  "exhaustive": {
    "nbHits": true
  },
  "query": "",
  "params": "filters=purpose:\"for-rent\" AND rentFrequency:\"monthly\" AND price>=10000.0 AND price<=50000.0 AND rooms>=1.0 AND baths>=1.0 AND ( location.externalID:\"5002\" ) AND category.externalID:\"4\" &hitsPerPage=25&page=0",
  "processingTimeMS": 13,
  "processingTimingsMS": {
    "afterFetch": {
      "format": {
        "total": 2
      },
      "total": 4
    },
    "fetch": {
      "scanning": 8,
      "total": 9
    },
    "total": 13
  }
}